// import React, { useEffect, useState, useRef } from 'react';
// import { useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
// import _ from 'lodash';
// import { SettingOutlined, Button, Badge, message, Spin, Input, Space, notification, Switch, Popconfirm } from 'antd';
// import { renderTableColumns } from '../../common/renderColumns';
// import { DropOutReasonModal, SearchFiltersPanel } from './';
// import moment from 'moment';
// import { SLASH_DATE_FORMAT } from '../../common/constants';
// import { CommonTable } from '../common';
// import ColumnSelectionModal from './ColumnSelectionModal';

// import { useResponsive } from './useResponsive';

// import {
//   useFetchOutsData, useFetchDropoutsData, useFetchInventoryData, useResetOutsData, useResetDropoutsData,
//   useExportOutsData, useResetOrderDetailData, useResetInventoryDetailData, useFetchRecommendedProducts, useResetRecommendedProducts,
//   useResetSubstituteProducts, useRemoveDropOuts, useRemoveAllocatedItem, useAllocateOriginalItem, useCheckOutsLock, useUpdateOutsRecordLock,
//   useSaveSearchConditionData, useSaveOrderDetailData, useAlerts, useFetchBosTerritoryData, useUpdateSubstitutionsData, useFetchDropOutsReason,
// } from './redux/hooks';
// // import { useFetchTerritoryData } from '../dashboard/redux/hooks';
// import ManageOutsOperateModalMobile from './ManageOutsOperateModalMobile';
// import ManageOutsOperateModal from './ManageOutsOperateModal';
// import ManageOutsAddSubMobile from './ManageOutsAddSubMobile';
// import { CONST_PAGINATION_TEN, COMMON_DATE_FORMAT, DATE_TIME_TWO_FORMAT, BOS_SEARCH_CONDITION_KEY, SIA_TEST_USER_ID_KEY, BOS_TERRITORY_DATA_KEY } from '../../common/constants';
// import ManageOutsWarningModal from './ManageOutsWarningModal';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFileExport, faArrowsRotate, faEye, faGears } from '@fortawesome/free-solid-svg-icons';
// import { CartIcon, EditIcon, DropIcon } from '../common/CustomerIcons';
// import { SearchOutlined, StopOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
// import { uniqueTerritoryList } from './getOriginalSelectedList';
// import { formatTerrirotyData } from './formattedSearchCondition';
// import { CONST_DROP_OUT_CST_FLAG_FROM_CCC, CONST_ROLE_OPTIONS_CCC, CONST_ROLE_OPTIONS_CST } from '../../common/manageOutsConstants';
// import { CORP_USER_LIST } from '../../common/corpProfile';
// import { datadogRum } from '@datadog/browser-rum';
// import { validateGroupIdRegExp } from './formattedSubsData';
// import { useRetainConditionData } from './redux/hooks';
// import { CustomerTitle } from './OgmSubs';

// export default function ManageOutsMobile() {
//   const {
//     outsData,
//     orderDetail,
//     fetchOutsDataPending,
//     dropoutsData,
//     fetchDropoutsDataPending,
//     searchConditionData,
//     exportOutsDataPending,
//     checkOutsLockPending,
//     updateOutsRecordLockPending,
//     removeDropOutsPending,
//     removeAllocatedItemPending,
//     allocateOriginalItemPending,
//     bosTerritory,
//     originalList,
//     userId,
//     conditionData,
//   } = useSelector(state => ({
//     outsData: state.manageSubs.outsData,
//     orderDetail: state.manageSubs.orderDetail,
//     fetchOutsDataPending: state.manageSubs.fetchOutsDataPending,
//     dropoutsData: state.manageSubs.dropoutsData,
//     fetchDropoutsDataPending: state.manageSubs.fetchDropoutsDataPending,
//     searchConditionData: state.manageSubs.searchConditionData,
//     exportOutsDataPending: state.manageSubs.exportOutsDataPending,
//     checkOutsLockPending: state.manageSubs.checkOutsLockPending,
//     updateOutsRecordLockPending: state.manageSubs.updateOutsRecordLockPending,
//     removeDropOutsPending: state.manageSubs.removeDropOutsPending,
//     removeAllocatedItemPending: state.manageSubs.removeAllocatedItemPending,
//     allocateOriginalItemPending: state.manageSubs.allocateOriginalItemPending,
//     bosTerritory: state.manageSubs.bosTerritoryData,
//     originalList: state.manageSubs.originalList,
//     userId: state.home.auth.user.userId,
//     conditionData: state.manageSubs.conditionData,
//   }));

//   const { auth } = useSelector(state => ({
//     auth: state.home.auth,
//   }));
//   const { fetchBosTerritoryData } = useFetchBosTerritoryData();
//   const { fetchOutsData } = useFetchOutsData();
//   const { fetchDropOutsReason } = useFetchDropOutsReason();
//   const { fetchDropoutsData } = useFetchDropoutsData();
//   const { fetchInventoryData } = useFetchInventoryData();
//   const { resetOutsData } = useResetOutsData();
//   const { resetDropoutsData } = useResetDropoutsData();
//   const { exportOutsData } = useExportOutsData();
//   const { resetOrderDetailData } = useResetOrderDetailData();
//   const { resetInventoryDetailData } = useResetInventoryDetailData();
//   const { fetchRecommendedProducts } = useFetchRecommendedProducts();
//   const { resetRecommendedProducts } = useResetRecommendedProducts();
//   const { resetSubstituteProducts } = useResetSubstituteProducts();
//   const { removeDropOuts } = useRemoveDropOuts();
//   const { alerts } = useAlerts();
//   const { removeAllocatedItem } = useRemoveAllocatedItem();
//   const { allocateOriginalItem } = useAllocateOriginalItem();
//   const { checkOutsLock } = useCheckOutsLock();
//   const { updateOutsRecordLock } = useUpdateOutsRecordLock();
//   const { saveOrderDetailData } = useSaveOrderDetailData();
//   const { retainConditionData } = useRetainConditionData();
//   const [isOrderDetailModalVisible, setOrderDetailModalVisible] = useState(false);
//   const [isInventoryDetailModalVisible, setInventoryDetailModalVisible] = useState(false);
//   //viewdropout
//   const [isViewDropOutVisible, setViewDropOutModalVisible] = useState(false);
//   const [isAddSubModalVisible, setAddSubModalVisible] = useState(false);
//   const [isLockedWarningModalVisible, setLockedWarningModalVisible] = useState(false);
//   const [sorting, setSorting] = useState({ sort: 'descend', sortedBy: 'orderNumber' });
//   const [baseData, setBaseData] = useState(null);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [isAsohAvailableWarningVisible, setAsohAvailableWarningVisible] = useState(false);
//   const [isOnClickRefresh, setOnClickRefresh] = useState(false);

//   const { saveSearchConditionData } = useSaveSearchConditionData();
//   const [searchText, setSearchText] = useState('');
//   const [searchedColumn, setSearchedColumn] = useState('');
//   const [isDropOutResonVisible, setDropOutReasonVisible] = useState(false);
//   const [dropOutRecord, setDropOutRecord] = useState(null);
//   const [dropOutReason, setDropOutReason] = useState("DR001");
//   const [isReasonCodeHint, setReasonCodeHint] = useState(false)
//   const [allocatedRecord, setAllocatedRecord] = useState(null)
//   const { updateSubstitutionsData } = useUpdateSubstitutionsData();
//   const [expandedRows, setExpandedRows] = useState(new Set());
//   const [isColumnSelectionVisible, setColumnSelectionVisible] = useState(false);

//   const [visibleColumns, setVisibleColumns] = useState([
//     'site',
//     'nationalId',
//     'originalItem',
//     'asoh',
//     'totalOrders',
//     //'totalOuts',  // Add this from desktop version
//     //'cutoff',     // Add this from desktop version 
//     'ruleType'    // Actions column
//   ]);
//   // const [optimizationEnable,setOptimizationEnable] = useState(true);  //COT-8330
//   const location = useLocation();
//   const settingsButtonRef = useRef(null);
//   const [isTablet, setIsTablet] = useState(false);

//   // Detect tablet vs mobile phone
//   useEffect(() => {
//     const checkIsTablet = () => {
//       setIsTablet(window.innerWidth >= 600 && window.innerWidth <= 800);
//     };
//     checkIsTablet();
//     window.addEventListener('resize', checkIsTablet);
//     return () => window.removeEventListener('resize', checkIsTablet);
//   }, []);

//   let storagedCondition = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY));
//   const bosTerritoryData = JSON.parse(sessionStorage.getItem(BOS_TERRITORY_DATA_KEY));
//   useEffect(() => {
//     if (storagedCondition) {
//       setSearchText(storagedCondition?.originalItem);
//     }
//   }, [storagedCondition]);
//   const [sortedInfo, setSortedInfo] = useState({  //COT-10012,customerized sorter, promote sorting to parent component, so change the state
//     sort: 'ascend',
//     sortedBy: 'cutoff',
//   });

//   useEffect(() => {
//     let sessionUserId = sessionStorage.getItem(SIA_TEST_USER_ID_KEY);
//     let userId = auth.user.userId;
//     if (!_.isEmpty(sessionUserId)) {
//       if (sessionUserId !== userId) {
//         userId = sessionUserId;
//       }
//     }
//     fetchBosTerritoryData({ userId, "isSpecial": true });
//   }, []);//eslint-disable-line

//   useEffect(() => {
//     if (isViewDropOutVisible) {
//       // Add End Date column when viewing dropouts
//       setVisibleColumns(prev => {
//         if (!prev.includes('endDate')) {
//           // Insert endDate before ruleType (Actions)
//           const newColumns = [...prev];
//           const actionsIndex = newColumns.indexOf('ruleType');
//           if (actionsIndex > -1) {
//             newColumns.splice(actionsIndex, 0, 'endDate');
//           } else {
//             newColumns.push('endDate');
//           }
//           return newColumns;
//         }
//         return prev;
//       });
//     } else {
//       // Remove End Date column when viewing regular outs
//       setVisibleColumns(prev => prev.filter(col => col !== 'endDate'));
//     }
//   }, [isViewDropOutVisible]);

//   const handleViewDropouts = () => {
//     const newViewState = !isViewDropOutVisible;
//     setViewDropOutModalVisible(newViewState);
//     retainConditionData({ ...conditionData, isViewDropOutVisible: newViewState });
//   };

//   const handleColumnChange = (newVisibleColumns) => {
//     setVisibleColumns(newVisibleColumns);
//     sessionStorage.setItem('manageOutsVisibleColumns', JSON.stringify(newVisibleColumns));
//   };

//   // Add this function to handle gear button click
//   const handleSettingsClick = () => {
//     setColumnSelectionVisible(true);
//   };

//   // Add this useEffect to load saved column preferences
//   useEffect(() => {
//     const savedColumns = sessionStorage.getItem('manageOutsVisibleColumns');
//     if (savedColumns) {
//       const parsed = JSON.parse(savedColumns);
//       // Ensure Actions column is always included
//       const columnsWithActions = [...new Set([...parsed, 'ruleType'])];
//       setVisibleColumns(columnsWithActions);
//     }
//   }, []);
//   const END_DATE_COLUMN = {
//     title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='endDate' title='End Date' />,
//     dataIndex: 'endDate',
//     width: 110,
//     blankWidth: 110,
//     sortOrder: sortedInfo.sortedBy === 'endDate' ? sortedInfo.sort : null,
//     render: value => value ? moment(value).format(SLASH_DATE_FORMAT) : '',
//   };
//   const onTableChange = (page, filters, sorter) => {
//     const sort =
//       Object.keys(sorter).length > 0 && sorter.order !== undefined
//         ? {
//           sortedBy: sorter.field,
//           sort: sorter.order,
//         }
//         : {
//           sortedBy: 'orderNumber',
//           sort: 'descend',
//         };
//     setSorting(sort);
//     const formData = {
//       orderDetail,
//       ...sort,
//     }
//     saveOrderDetailData(formData);
//   };
//   const onToggleModal = updateState => {
//     updateState(prevState => {
//       return !prevState;
//     });
//   }
//   const onExportOuts = () => {
//     const params = { ...searchConditionData }
//     if (searchText) {
//       params.originalItem = searchText
//     }
//     params.callFrom = isViewDropOutVisible ? 'dropOuts' : 'outs'
//     params.optimizationEnable = true;   //COT-8330,If remove optimization toggle,need hardcode optimizationEnable for export api
//     const context = datadogRum.getGlobalContext('BosView');
//     const timing = Date.now();
//     exportOutsData(params);
//     datadogRum.onReady(function () {
//       datadogRum.addTiming(`Export ${context.BosView.screen} data`, timing);
//     });
//   }
//   const onRefreshOuts = () => {


//     // if(searchConditionData) {
//     //   const formData = {
//     //     ...searchConditionData,
//     //     pageIndex: CONST_PAGINATION_TEN.pageIndex,
//     //     pageSize: CONST_PAGINATION_TEN.pageSize,
//     //    // ...outsSortingForRefresh
//     //   };
//     //   if(searchText) {
//     //     formData.originalItem = searchText
//     //   }
//     //   if(isViewDropOutVisible) {
//     //     fetchDropoutsData(formData);
//     //   }else {
//     //     fetchOutsData(formData);
//     //   }
//     //defect:cot-5316,when click reload will reset ccc/cst local option as same as search condition
//     setOnClickRefresh(!isOnClickRefresh);
//     // }
//   }
//   //defect: order detail re-design
//   const handleViewOrderDetail = (record) => {
//     saveOrderDetailData({ orderDetail: record.orderDetailBeans });
//     onToggleModal(setOrderDetailModalVisible);
//   }
//   const handleViewInventoryDetail = (record) => {
//     let inventoryCondition = {
//       // products: [
//       //   {
//       //     supc: record.originalItem,
//       //     splitFlag: false,
//       //   }
//       // ],
//       // businessUnitNumber: record.site,
//       site: record.site,
//       conceptId: !_.isEmpty(record.nationalId) ? record.nationalId : record.customerNumber,
//       originalItem: record.originalItem
//     }
//     const timing = Date.now();
//     fetchInventoryData(inventoryCondition);
//     datadogRum.onReady(function () {
//       datadogRum.addTiming(`Fetch inventory`, timing);
//     });
//     onToggleModal(setInventoryDetailModalVisible);
//   }

//   const handleCheckOutsLock = (record) => {
//     setSelectedRecord(record);
//     const formData = {
//       site: record.site,
//       itemNumber: record.originalItem,
//       orders: record.orderNumbers
//     }
//     checkOutsLock(formData).then((response) => {
//       if (response && response[0].recordLockFlag === 'Y') {
//         onToggleModal(setLockedWarningModalVisible);
//       } else {
//         handleAddSub(record);
//       }
//     }, (err) => {
//       message.destroy();
//       message.error(err);
//     })
//   }
//   const handleUpdateOutsRecordLock = (record) => {
//     const formData = {
//       site: record.site,
//       itemNumber: record.originalItem,
//       recordLockFlag: !isAddSubModalVisible ? 'Y' : 'N',
//       orders: record.orderNumbers
//     }
//     updateOutsRecordLock(formData).then((response) => {
//     }, (err) => {
//       message.error(`Update Outs Record Lock Failed, please try again.`);
//     });
//   }
//   //COT-8253:UI-Ability for CCC Agents to Select Reason for Dropped Items
//   const handleRemoveDropOut = (record) => {
//     if (record) {
//       const nowTime = moment().format(DATE_TIME_TWO_FORMAT)
//       let formData = {
//         site: record.site,
//         siteDesc: record.siteDesc,
//         originalItem: record.originalItem,
//         originalBrand: record.originalItemBrand,
//         // originalItemCategory
//         originalItemDescription: record.originalItemDescription,
//         originalPack: record.originalItemPack,
//         originalSize: record.originalItemSize,
//         // originalSplitIndicator
//         originalStorageCode: record.originalItemStorageCode,
//         originalUom: record.originalItemUom,
//         orders: record.orderDetailBeans.map(item => item.orderNumber),
//         orderLines: record.orderDetailBeans.map(item => item.orderLine),
//         customerNumbers: record.orderDetailBeans.map(item => item.customerShipTo),
//         nationalId: record.nationalId ? record.nationalId : "",
//         nationalName: record.nationalName ? record.nationalName : "",
//         customerNumber: record.customerNumber ? record.customerNumber : "",
//         customerName: record.customerName ? record.customerName : "",
//         createdById: auth.user.userId,
//         createdByName: auth.user.userName,
//         createTimestamp: nowTime,
//         modifiedById: auth.user.userId,
//         modifiedByName: auth.user.userName,
//         modifiedTimestamp: nowTime,
//         // endDate: (searchConditionData.deliveryDate + '').replace(/^(\d{4})(\d{2})(\d{2})$/, "$2/$3/$1"),
//         endDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
//       };
//       if (searchConditionData && searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC && !_.isEmpty(record.categorizationFlag)) {
//         formData = { ...formData, dropFlag: CONST_DROP_OUT_CST_FLAG_FROM_CCC }
//       }
//       if (searchConditionData && searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC) {
//         formData = { ...formData, dropOutReason: dropOutReason, managedBy: 'CCC' }
//       }
//       removeDropOuts(formData)
//         .then(
//           response => {
//             resetOutsData();
//             if (
//               searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC ||
//               searchConditionData.managedBy === CONST_ROLE_OPTIONS_CST
//             ) {
//               //Alerts API
//               const data = [];
//               for (let order of record.orderDetailBeans) {
//                 const formData = {
//                   nationalCustomerId: record.nationalId ? record.nationalId : '',
//                   createdByUserId: auth.user.userId ? auth.user.userId : '',
//                   createdDate: moment().format('MM/DD/YYYY'),
//                   customerNumber: order.customerShipTo,
//                   modifiedByUserId: auth.user.userId ? auth.user.userId : '',
//                   modifiedDate: moment().format('MM/DD/YYYY'),
//                   orderDetailLineNumber: order.orderLine,
//                   orderNumber: order.orderNumber,
//                   originalItem: record.originalItem,
//                   opcoNumber: record.site,
//                   substituteItemNumber: '',
//                   substituteQuantity: '',
//                   splitCode: '',
//                   salesForceId: '',
//                   managedBy: searchConditionData.managedBy,
//                   category: record.categorizationFlag,
//                   alertType: '',
//                   batchIdType: '',
//                   dropDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
//                 };
//                 data.push(formData);
//               }
//               alerts(data);
//             }
//             const params = { ...searchConditionData };
//             if (searchText) {
//               params.originalItem = searchText;
//             }
//             fetchOutsData({ ...params });
//             message.info('Drop Outs Successfully.');
//           },
//           err => {
//             message.destroy();
//             message.error(`Drop Outs Failed, please try again.`);
//           },
//         )
//         .finally(() => {
//           cancelReasonModal();
//         });
//     }
//   }
//   const cancelReasonModal = () => {
//     onToggleModal(setDropOutReasonVisible);
//     updateOutsRecordLock({
//       site: dropOutRecord.site,
//       itemNumber: dropOutRecord.originalItem,
//       recordLockFlag: 'N',
//       orders: dropOutRecord.orderNumbers,
//     }).then(
//       response => { },
//       err => { message.error(`Update Outs Record Lock Failed, please try again.`); },
//     );
//   };
//   const handleDropOuts = (record) => {
//     const timing = Date.now();
//     const lockData = {
//       site: record.site,
//       itemNumber: record.originalItem,
//       orders: record.orderNumbers,
//     }
//     checkOutsLock(lockData).then((response) => {
//       if (response && response[0].recordLockFlag === 'Y') {
//         onToggleModal(setLockedWarningModalVisible);
//       } else {
//         //COT-8253:BOS 2.0 - UI-Ability for CCC Agents to Select Reason for Dropped Items
//         if (searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC) {
//           setDropOutRecord(record);
//           fetchDropOutsReason({ requestApprovalFlag: !!record.requestApprovalFlag });
//           onToggleModal(setDropOutReasonVisible);
//           updateOutsRecordLock({
//             site: record.site,
//             itemNumber: record.originalItem,
//             recordLockFlag: 'Y',
//             orders: record.orderNumbers,
//           }).then((response) => { }, (err) => {
//             message.error(`Update Outs Record Lock Failed, please try again.`);
//           });
//         } else {
//           const nowTime = moment().format(DATE_TIME_TWO_FORMAT)
//           let formData = {
//             site: record.site,
//             siteDesc: record.siteDesc,
//             originalItem: record.originalItem,
//             originalBrand: record.originalItemBrand,
//             // originalItemCategory
//             originalItemDescription: record.originalItemDescription,
//             originalPack: record.originalItemPack,
//             originalSize: record.originalItemSize,
//             // originalSplitIndicator
//             originalStorageCode: record.originalItemStorageCode,
//             originalUom: record.originalItemUom,
//             orders: record.orderDetailBeans.map(item => item.orderNumber),
//             orderLines: record.orderDetailBeans.map(item => item.orderLine),
//             customerNumbers: record.orderDetailBeans.map(item => item.customerShipTo),
//             nationalId: record.nationalId ? record.nationalId : "",
//             nationalName: record.nationalName ? record.nationalName : "",
//             customerNumber: record.customerNumber ? record.customerNumber : "",
//             customerName: record.customerName ? record.customerName : "",
//             createdById: auth.user.userId,
//             createdByName: auth.user.userName,
//             createTimestamp: nowTime,
//             modifiedById: auth.user.userId,
//             modifiedByName: auth.user.userName,
//             modifiedTimestamp: nowTime,
//             // endDate: (searchConditionData.deliveryDate + '').replace(/^(\d{4})(\d{2})(\d{2})$/, "$2/$3/$1"),
//             endDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
//             //COT-8253:BOS 2.0 - UI-Ability for CCC Agents to Select Reason for Dropped Items
//             dropOutReason: null,
//             managedBy: searchConditionData.managedBy,
//           };
//           if (searchConditionData && searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC && !_.isEmpty(record.categorizationFlag)) {
//             formData = { ...formData, dropFlag: CONST_DROP_OUT_CST_FLAG_FROM_CCC }
//           }
//           updateOutsRecordLock({
//             site: record.site,
//             itemNumber: record.originalItem,
//             recordLockFlag: 'Y',
//             orders: record.orderNumbers,
//           }).then((response) => {

//             removeDropOuts(formData).then((response) => {
//               resetOutsData();
//               if (searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC || searchConditionData.managedBy === CONST_ROLE_OPTIONS_CST) {
//                 //Alerts API
//                 const data = [];
//                 for (let order of record.orderDetailBeans) {
//                   const formData = {
//                     nationalCustomerId: record.nationalId ? record.nationalId : "",
//                     createdByUserId: auth.user.userId ? auth.user.userId : "",
//                     createdDate: moment().format("MM/DD/YYYY"),
//                     customerNumber: order.customerShipTo,
//                     modifiedByUserId: auth.user.userId ? auth.user.userId : "",
//                     modifiedDate: moment().format("MM/DD/YYYY"),
//                     orderDetailLineNumber: order.orderLine,
//                     orderNumber: order.orderNumber,
//                     originalItem: record.originalItem,
//                     opcoNumber: record.site,
//                     substituteItemNumber: "",
//                     substituteQuantity: "",
//                     splitCode: "",
//                     salesForceId: "",
//                     managedBy: searchConditionData.managedBy,
//                     category: record.categorizationFlag,
//                     alertType: "",
//                     batchIdType: "",
//                     dropDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,

//                   }
//                   data.push(formData);
//                 }

//                 alerts(data);


//               }
//               const params = { ...searchConditionData }
//               if (searchText) {
//                 params.originalItem = searchText
//               }
//               fetchOutsData(params);
//               message.info('Drop Outs Successfully.');
//             },
//               (err) => {
//                 message.destroy();
//                 message.error(`Drop Outs Failed, please try again.`);
//               });
//           }).catch((err) => {
//             message.error(`Update Outs Record Lock Failed, please try again.`);
//           }).finally(() => {
//             updateOutsRecordLock({
//               site: record.site,
//               itemNumber: record.originalItem,
//               recordLockFlag: 'N',
//               orders: record.orderNumbers,
//             })
//           });
//         }
//       }
//     }, (err) => {
//       message.destroy();
//       message.error(err);
//     })
//     datadogRum.onReady(function () {
//       datadogRum.addTiming(`Drop outs`, timing);
//     });
//   }
//   const handleAddSub = (record) => {
//     //COT-7911,If Substitute from dropOuts page need pass orderLines parameter in updateSubstitutionsData api
//     let orderNumbers = [];
//     let orderLines = [];
//     let customerNumbers = [];
//     for (let order of record.orderDetailBeans) {
//       orderNumbers.push(String(order.orderNumber));
//       orderLines.push(order.orderLine);
//       // if(validateGroupIdRegExp(record.nationalId)){
//       customerNumbers.push(order.customerShipTo);
//       // }
//     }
//     setBaseData({
//       "site": record.site,
//       "siteDesc": record.siteDesc,
//       "nationalId": record.nationalId,
//       "nationalName": record.nationalName,
//       "customerNumber": record.customerNumber,
//       "customerName": record.customerName,
//       "conceptId": record.nationalId ? record.nationalId : record.customerNumber,
//       "conceptName": record.nationalName ? record.nationalName : record.customerName,
//       "originalItem": record.originalItem,
//       "originalItemDescription": record.originalItemDescription,
//       "originalItemUom": record.originalItemUom,
//       "originalPack": record.originalItemPack,
//       "originalSize": record.originalItemSize,
//       "kosher": record.kosher,//COT-5366 show original item kosher
//       "originalBrand": record.originalItemBrand,
//       "originalStorageCode": record.originalItemStorageCode,
//       "casePrice": '---',
//       "caseQuantity": record.asoh,
//       "isFromOuts": true,
//       "orderNumbers": orderNumbers, //COT-7911,If Substitute from dropOuts page need pass orderLines parameter in updateSubstitutionsData api
//       "orderLines": orderLines, //COT-7911,If Substitute from dropOuts page need pass orderLines parameter in updateSubstitutionsData api
//       "deliveryDate": document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
//       "totalOuts": record.totalOuts,
//       "searchText": searchText,
//       "callFrom": isViewDropOutVisible ? 'dropOuts' : 'outs',
//       "customerNumbers": customerNumbers,
//     })
//     const timing = Date.now();
//     fetchRecommendedProducts({
//       "searchBy": "Item Description",
//       "searchInput": record.originalItemDescription,
//       "site": [record.site],
//       "originalItemUom": record.originalItemUom,
//       "originalItem": record.originalItem,
//       "nationalId": record.nationalId,
//       "customerNumber": record.customerNumber,
//       "isFromOuts": true,
//       "totalOuts": record.totalOuts,
//       "searchFor":"Recommended Products",
//     })
//       .catch(err => {
//         //message.error(`Search Recommended Substitutions Failed, please try again.`);
//         message.error(`${err}`); //COT-10152
//       });
//     datadogRum.onReady(function () {
//       datadogRum.addTiming(`Fetch Recommended Products`, timing);
//     });
//     onToggleModal(setAddSubModalVisible);
//     handleUpdateOutsRecordLock(record);
//   }
//   const resetOrderDetail = () => {
//     resetOrderDetailData();
//   }
//   const resetInventoryData = () => {
//     resetInventoryDetailData();
//   }
//   const handleAllocateOriginalItem = (record) => {
//     setAllocatedRecord(record)
//     const lockData = {
//       site: record.site,
//       itemNumber: record.originalItem,
//       orders: record.orderNumbers,
//     }

//     checkOutsLock(lockData).then((response) => {
//       if (response && response[0].recordLockFlag === 'Y') {
//         onToggleModal(setLockedWarningModalVisible);
//       } else {
//         if (record.asoh < record.totalOuts) {
//           onToggleModal(setAsohAvailableWarningVisible);
//         } else {
//           onToggleModal(setReasonCodeHint);
//         }
//       }
//     }, (err) => {
//       message.destroy();
//       message.error(err);
//     })
//   }

//   const CONST_OUTS_TABLE_COLUMNS = [
//     {
//       title: 'Site ID',
//       dataIndex: 'site',
//       width: 100,
//       blankWidth: 100,
//       // sorter: true,
//       render: false,
//       extendRender: true,
//       onCell: (record, rowIndex) => {
//         if (record.requestApprovalFlag) {
//           return {
//             style: {
//               borderLeft: 'solid 3px #ff0000'
//             }
//           }
//         } else {
//           return {}
//         }
//       },
//     },
//     {
//       // title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='nationalId' title='Group/Ship To'/>,
//       title: 'Group/Ship To',
//       dataIndex: 'nationalId',
//       width: 140,
//       blankWidth: 140,
//       // sorter: true,  //defect:COT-5601,Manage Outs - The sorting indicator in the columns remains highlighted on reloading the data in Manage Outs page
//       render: false,
//       extendRender: true,
//       //sortOrder: sortedInfo.sortedBy === 'nationalId' ? sortedInfo.sort : null,
//     },
//     {
//       //title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='originalItem' title='Original Item'/>,
//       title: 'Original Item',
//       dataIndex: 'originalItem',
//       width: 190,
//       blankWidth: 190,
//       // sorter: true,
//       sortOrder: sortedInfo.columnKey === 'originalItem' ? sortedInfo.order : null,
//       render: false,
//       extendRender: true,
//     },
//     {
//       title: 'ASOH',
//       dataIndex: 'asoh',
//       width: 70,
//       blankWidth: 70,
//       // sorter: true,
//       render: false,
//       render: (text, record) =>renderCellAsoh(text,record)
//     },
//     {
//       title: 'Total Orders',
//       dataIndex: 'totalOrders',
//       width: 100,
//       blankWidth: 100,
//       // sorter: true,
//       render: false,
//       render: (text, record) =>renderCellTotalOrders(text,record)
//     },
//     // {
//     //   title: 'Total Outs',
//     //   dataIndex: 'totalOuts',
//     //   width: 90,
//     //   blankWidth: 90,
//     //   // sorter: true,
//     //   render: false,
//     // },
//     // {
//     //   title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='cutoff' title='Cutoff'/>,
//     //   dataIndex: 'cutoff',
//     //   width: 70,
//     //   blankWidth: 70,
//     //   // sorter: true,
//     //   sortOrder: sortedInfo.sortedBy === 'cutoff' ? sortedInfo.sort : null,
//     //   render: false,
//     // },
//     //COT-10373 EndDate column for View Dropouts page
//     {
//       title: 'End Date', // Add the End Date column
//       dataIndex: 'endDate',
//       width: 110,
//       blankWidth: 110,
//       render: value => value ? moment(value).format(SLASH_DATE_FORMAT) : '',
//     },// EndDate column for View Dropouts page
//   ];
//   const buildColumnsForTable = () => {
//     // First, apply search props to the original item column
//     const columnsWithSearch = [...CONST_OUTS_TABLE_COLUMNS];
//     const originalItemColumnIndex = columnsWithSearch.findIndex(col => col.dataIndex === 'originalItem');

//     if (originalItemColumnIndex !== -1) {
//       columnsWithSearch[originalItemColumnIndex] = {
//         ...columnsWithSearch[originalItemColumnIndex],
//         ...getColumnSearchProps('originalItem')
//       };
//     }

//     // Then render the columns using renderTableColumns
//     let baseColumns = renderTableColumns(columnsWithSearch, null, renderOutsParentElement);


//     //COT-10373 EndDate column for View Dropouts page
//     // Find index of Cutoff column for conditional End Date insertion
//     const cutoffIdx = baseColumns.findIndex(col => col.dataIndex === 'cutoff');
//     //COT-10373 EndDate column for View Dropouts page

//     //   // Conditionally insert End Date column for View DropOut page
//     //   if (isViewDropOutVisible && cutoffIdx !== -1) {
//     //     baseColumns.splice(cutoffIdx + 1, 0, END_DATE_COLUMN);
//     //   }

//     // Add Actions column
//     const actionsColumn = {
//       title: 'Actions',
//       dataIndex: 'ruleType',
//       width: 60,
//       blankWidth: 60,
//       fixed: 'right',
//       render: (value, record) => {
//         const recordKey = `${record.uid}-${record.site}-${record.nationalId}-${record.customerNumber}-${record.originalItem}-${record.originalItemUom}`;
//         const isExpanded = expandedRows.has(recordKey);

//         return (
//           <div style={{ position: 'relative' }}>
//             <Button
//               type="link"
//               onClick={() => toggleActionsDropdown(recordKey)}
//               style={{
//                 padding: '4px 8px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               {isExpanded ? (
//                 <CaretUpOutlined style={{ fontSize: '12px', color: '#6b6b6c' }} />
//               ) : (
//                 <CaretDownOutlined style={{ fontSize: '12px', color: '#6b6b6c' }} />
//               )}
//             </Button>

//             {isExpanded && (
//               <div
//                 style={{
//                   position: 'absolute',
//                   top: '85%',
//                   right: '52px',
//                   background: '#fff',
//                   border: '1px solid #d9d9d9',
//                   borderRadius: '6px',
//                   boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
//                   zIndex: 99999,
//                   padding: '8px 0',
//                   minWidth: '190px',
//                   width: '190px',
//                   marginTop: '-20px'
//                 }}
//               >
//                 {/* Your existing dropdown content */}
//                 <div
//                   onClick={() => {
//                     handleCheckOutsLock(record);
//                     setExpandedRows(new Set());
//                   }}
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '12px 16px',
//                     cursor: 'pointer',
//                     transition: 'background-color 0.2s'
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
//                 >
//                   <span style={{
//                     fontSize: '12px',
//                     color: '#333',
//                     fontWeight: '400',
//                     width: '130px',
//                     textAlign: 'left',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     whiteSpace: 'nowrap'
//                   }}>
//                     Search for Sub
//                   </span>
//                   <div style={{
//                     width: '24px',
//                     height: '24px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     flexShrink: 0
//                   }}>
//                     <EditIcon style={{ fontSize: '16px', color: '#6b6b6c' }} />
//                   </div>
//                 </div>

//                 {/* Include all your other action items */}
//                 <div style={{ height: '1px', background: '#e8e8e8', margin: '0 8px' }}></div>

//                 {!isViewDropOutVisible && (
//                   <>
//                     <div
//                       onClick={() => {
//                         handleDropOuts(record);
//                         setExpandedRows(new Set());
//                       }}
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         padding: '12px 16px',
//                         cursor: 'pointer',
//                         transition: 'background-color 0.2s'
//                       }}
//                     >
//                       <span style={{
//                         fontSize: '12px',
//                         color: '#333',
//                         fontWeight: '400',
//                         width: '130px',
//                         textAlign: 'left',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         whiteSpace: 'nowrap'
//                       }}>
//                         Drop Out
//                       </span>
//                       <div style={{
//                         width: '24px',
//                         height: '24px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         flexShrink: 0
//                       }}>
//                         <DropIcon style={{ fontSize: '16px', color: '#6b6b6c' }} />
//                       </div>
//                     </div>
//                     <div style={{ height: '1px', background: '#e8e8e8', margin: '0 8px' }}></div>
//                   </>
//                 )}

//                 <div
//                   onClick={() => {
//                     handleAllocateOriginalItem(record);
//                     setExpandedRows(new Set());
//                   }}
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '12px 16px',
//                     cursor: 'pointer',
//                     transition: 'background-color 0.2s'
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
//                 >
//                   <span style={{
//                     fontSize: '12px',
//                     color: '#333',
//                     fontWeight: '400',
//                     width: '130px',
//                     textAlign: 'left',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     whiteSpace: 'nowrap'
//                   }}>
//                     Allocate Original Item
//                   </span>
//                   <div style={{
//                     width: '24px',
//                     height: '24px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     flexShrink: 0
//                   }}>
//                     <CartIcon style={{ fontSize: '16px', color: '#6b6b6c' }} />
//                   </div>
//                 </div>

//                 <div style={{ height: '1px', background: '#e8e8e8', margin: '0 8px' }}></div>

//                 <Popconfirm
//                   title="Are you sure would like to mark to Never sub?"
//                   onConfirm={() => {
//                     updateToNeverSub(record);
//                     setExpandedRows(new Set());
//                   }}
//                   okText="Yes"
//                   cancelText="No"
//                   placement="leftTop"
//                   getPopupContainer={() => document.body}
//                   overlayStyle={{ zIndex: 100000 }}
//                   //COT-10411
//                   onCancel={() => {
//                     // Close the dropdown when user cancels the popconfirm
//                     setExpandedRows(new Set());
//                   }}
//                 >
//                   <div
//                   //COT-10411
//                     onClick={(e) => {
//                       // Stop propagation to prevent the click outside handler from triggering
//                       e.stopPropagation();
//                     }}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       padding: '12px 16px',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.2s'
//                     }}
//                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
//                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
//                   >
//                     <span style={{
//                       fontSize: '12px',
//                       color: '#333',
//                       fontWeight: '400',
//                       width: '130px',
//                       textAlign: 'left',
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap'
//                     }}>
//                       Mark to Never Sub
//                     </span>
//                     <div style={{
//                       width: '24px',
//                       height: '24px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       flexShrink: 0
//                     }}>
//                       <StopOutlined style={{ fontSize: '16px', color: '#6b6b6c' }} />
//                     </div>
//                   </div>
//                 </Popconfirm>
//               </div>
//             )}
//           </div>
//         );
//       }
//     };

//     baseColumns.push(actionsColumn);

//     return baseColumns;
//   };

//   const getFilteredColumns = () => {
//     const allColumns = buildColumnsForTable();

//     return allColumns.filter(column => {
//       // Always show Actions column
//       if (column.dataIndex === 'ruleType') return true;
//       // Show other columns based on user selection
//       return visibleColumns.includes(column.dataIndex);
//     });
//   };

//   const getAllColumnsForModal = () => {
//     // Base columns from CONST_OUTS_TABLE_COLUMNS
//     const baseColumns = [...CONST_OUTS_TABLE_COLUMNS];

//     // Add additional columns that might be conditionally shown
//     const additionalColumns = [];

//     // Add Total Outs column (from desktop version)
//     // additionalColumns.push({
//     //   title: 'Total Outs',
//     //   dataIndex: 'totalOuts',
//     //   width: 90,
//     //   blankWidth: 90,
//     // });

//     // // Add Cutoff column (from desktop version)
//     // additionalColumns.push({
//     //   title: 'Cutoff',
//     //   dataIndex: 'cutoff',
//     //   width: 70,
//     //   blankWidth: 70,
//     // });

//     // Always add Actions column for display in modal
//     additionalColumns.push({
//       title: 'Actions',
//       dataIndex: 'ruleType'
//     });

//     return [...baseColumns, ...additionalColumns];
//   };
//   const handleTableChange = (pagination, filters, sorter) => {
//     setSortedInfo(sorter);
//   };
//   const resetSortedInfo = () => {
//     setSortedInfo({
//       sort: 'ascend',
//       sortedBy: 'cutoff',
//     });
//   };
//   const renderCellAsoh = (text, record) => {
//     return (
//       <div>
//         <Button type="link" block onClick={() => handleViewInventoryDetail(record)}>
//           {
//             `${record.asoh}`
//           }
//         </Button>
//       </div>
//     )
//   }
//   const renderCellTotalOrders = (text, record) => {
//     return (
//       <Button type="link" block onClick={() => handleViewOrderDetail(record)}>
//         {
//           `${record.totalOrders}`
//         }
//       </Button>
//     )
//   }
//   // const [pagination, setPagination] = useState(paginationSetting);
//   const renderAllocateOriginaItemlWarningModal = (
//     <ManageOutsWarningModal
//       title=""
//       isModalVisible={isAsohAvailableWarningVisible}
//       footer={false}
//       width={500}
//       onToggleModal={() => { onToggleModal(setAsohAvailableWarningVisible); }}
//       content="Available ASOH of the original item is not enough.Kindly add a subs item."
//     />
//   );
//   const handleCancel = () => {
//     onToggleModal(setReasonCodeHint);
//   };
//   const handleOk = () => {
//     onToggleModal(setReasonCodeHint);
//     const data = [];
//     for (let order of allocatedRecord.orderDetailBeans) {
//       const formData = {
//         accountOwner: "",
//         accountOwnerPhone: "",
//         action: "A",
//         approvalRequired: "",
//         bosCutOff: 0,
//         conceptId: allocatedRecord.nationalId ? allocatedRecord.nationalId : "",
//         createdBy: auth.user.userId ? auth.user.userId : "",
//         createdTimestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
//         customerNumber: order.customerShipTo,
//         dataType: "",
//         dropFlag: "",
//         effectiveEndDate: "",
//         inclusionExclusion: "",
//         localCentral: "",
//         modifiedBy: "",
//         modifiedTimestamp: "",
//         orderDetailLineNumber: order.orderLine,
//         orderNumber: order.orderNumber,
//         originalBrand: allocatedRecord.originalItemBrand ? allocatedRecord.originalItemBrand : '',
//         originalItem: allocatedRecord.originalItem,
//         originalItemDescription: allocatedRecord.originalItemDescription,
//         originalPack: allocatedRecord.originalItemPack ? allocatedRecord.originalItemPack : '',
//         originalSize: allocatedRecord.originalItemSize ? allocatedRecord.originalItemSize : '',
//         originalStorageCode: allocatedRecord.originalItemStorageCode ? allocatedRecord.originalItemStorageCode : '',
//         originalSplitIndicator: allocatedRecord.originalItemUom === 'EA' ? 'Y' : 'N',
//         reasonCode: "",
//         reasonCodeDescription: "",
//         ruleType: "AO",
//         site: allocatedRecord.site,
//         startOfDayEmail: "",
//         subOutOfCatalog: "",
//         subRatio: 0,
//         subrulePriority: 0,
//         substituteBrand: "",
//         substituteItem: "",
//         substituteItemDescription: "",
//         substitutePack: "",
//         substituteSize: "",
//         substituteStorageCode: "",
//         substitutelSplitIndicator: ""
//       }
//       data.push(formData);
//     }
//     const timing = Date.now();
//     allocateOriginalItem(data).then((response) => {
//       message.info('Allocate Original Item Successfully.');
//     },
//       (err) => {
//         message.destroy();
//         message.error(`Allocate Original Item Failed, please try again.`);
//       });
//     const removeData = {
//       site: allocatedRecord.site,
//       originalItem: allocatedRecord.originalItem,
//       nationalId: allocatedRecord.nationalId ? allocatedRecord.nationalId : "",
//       customerNumber: allocatedRecord.customerNumber ? allocatedRecord.customerNumber : "",
//       orders: allocatedRecord.orderNumbers,
//       createdById: auth.user.userId,
//       originalItemDescription: allocatedRecord.originalItemDescription,
//       callFrom: isViewDropOutVisible ? 'dropOuts' : 'outs',
//     };
//     removeAllocatedItem(removeData).finally(() => {
//       const payload = { ...searchConditionData }
//       if (searchText) {
//         payload.originalItem = searchText
//       }
//       //COT-8309:Latency issue when user drop out or search for subs in manage outs
//       // payload.optimizationEnable = optimizationEnable;  //COT-8330
//       if (isViewDropOutVisible) {
//         resetDropoutsData();
//         fetchDropoutsData({ ...payload });
//       } else {
//         resetOutsData();
//         fetchOutsData({ ...payload });
//       }
//     });
//     datadogRum.onReady(function () {
//       datadogRum.addTiming(`Allocate Original Item`, timing);
//     });
//   };
//   const renderDropOutResonModal = (
//     <DropOutReasonModal
//       // title=""
//       isModalVisible={isDropOutResonVisible}
//       footer={[
//         <Button key="back" className="default-btn" onClick={() => cancelReasonModal()}>
//           Cancel
//         </Button>,
//         <Button key="submit" type="primary" className='primary-btn' style={{ marginLeft: "6px" }} onClick={() => handleRemoveDropOut(dropOutRecord)}>
//           Proceed
//         </Button>,
//       ]}
//       width={400}
//       onToggleModal={() => cancelReasonModal()}
//       content="Please select drop out reason"
//       dropOutReason={dropOutReason}
//       setDropOutReason={setDropOutReason}
//       requestApprovalFlag={!!dropOutRecord?.requestApprovalFlag}
//     />
//   )
//   const renderReasonCodeHintModal = (
//     <ManageOutsWarningModal
//       title=""
//       isModalVisible={isReasonCodeHint}
//       footer={[
//         <Button key="back" className="default-btn" onClick={handleCancel}>
//           Cancel
//         </Button>,
//         <Button key="submit" type="primary" className='primary-btn' style={{ marginLeft: "6px" }} onClick={handleOk}>
//           Proceed
//         </Button>,
//       ]}
//       width={500}
//       onToggleModal={() => { onToggleModal(setReasonCodeHint); }}
//       content="The original item was not allocated due to the below reason codes"
//       record={allocatedRecord}
//       isReasonCodeHint={true}
//     />
//   );
//   const renderLockedWarningModal = (
//     <ManageOutsWarningModal
//       title=""
//       isModalVisible={isLockedWarningModalVisible}
//       footer={false}
//       width={500}
//       onToggleModal={() => { onToggleModal(setLockedWarningModalVisible); }}
//       content="Maintenance is disabled for this record as this is being worked on by another user session."
//     />
//   );

//   const renderOrderDetailModal = (
//     <ManageOutsOperateModalMobile
//       title="VIEW ORDER DETAILS"
//       isModalVisible={isOrderDetailModalVisible}
//       footer={false}
//       width={1100}
//       onToggleModal={() => { onToggleModal(setOrderDetailModalVisible); resetOrderDetail(); setSorting({ sort: 'descend', sortedBy: 'orderNumber' }) }}
//       onTableChange={onTableChange}
//       idle={() => { }}
//     />
//   );
//   const renderInventoryDetailModal = (
//     <ManageOutsOperateModalMobile
//       title="VIEW INVENTORY DETAILS"
//       isModalVisible={isInventoryDetailModalVisible}
//       footer={false}
//       width={650}
//       onToggleModal={() => { onToggleModal(setInventoryDetailModalVisible); resetInventoryData(); }}
//       idle={() => { }}

//     />
//   );
//   const renderAddSubModal = (
//     <ManageOutsOperateModalMobile
//       title="ADDSUB"
//       isModalVisible={isAddSubModalVisible}
//       footer={false}
//       width={1210}
//       onToggleModal={() => { onToggleModal(setAddSubModalVisible); resetRecommendedProducts(); resetSubstituteProducts(); handleUpdateOutsRecordLock(selectedRecord) }}
//       okText="Sub"
//       baseData={baseData}
//       idle={() => {
//         notification.warning({
//           message: `Idle Time Surpassed 5 minutes`,
//           placement: 'top',
//           duration: 0,
//         })
//       }}
//     // optimizationEnable={optimizationEnable}
//     />
//   );
//   const renderOutsParentElement = [
//     { //render siteID
//       extendRender: (value, label, record) => {
//         return (
//           <>
//             <div className="col-title">{value}</div>
//             <div className="col-desc">{record.siteDesc}</div>
//           </>
//         )
//       }
//     },
//     { //render conceptID
//       extendRender: (value, label, record) => {
//         //defect:COT-5285, prioritize customer if customerNumber and national Id are not empty
//         if (record.customerNumber && record.customerNumber.length > 0) {
//           return (
//             <>
//               <div className="col-title">{record.customerNumber}</div>
//               <div className="col-desc">{record.customerName}</div>
//             </>
//           )
//         }
//         return (
//           <>
//             <div className="col-title">{value}</div>
//             <div className="col-desc">{record.nationalName}</div>
//           </>
//         )
//         // if(value && value.length > 0) {
//         //   return (
//         //     <>
//         //       <div className="col-title">{value}</div>
//         //       <div className="col-desc">{record.nationalName}</div>
//         //     </>
//         //   )
//         // }
//         // return (
//         //   <>
//         //     <div className="col-title">{record.customerNumber}</div>
//         //     <div className="col-desc">{record.customerName}</div>
//         //   </>
//         // )
//       }
//     },
//     { //render originalItem
//       extendRender: (value, label, record) => {
//         let originalItemDetails = ``;
//         if (value) {
//           originalItemDetails = `${record.originalItemUom} | ${record.originalItemPack}/${record.originalItemSize} | ${record.originalItemBrand} | ${record.originalItemStorageCode}`;
//         }
//         let category = record.categorizationFlag;
//         let categoryIcon = '';
//         if (category) {
//           category = category.trim();
//           categoryIcon = category === 'C' ? <Badge className="sub-badge-item" color="#7AC943" />
//             : category === 'D' ? <Badge className="sub-badge-item" color="#FF931E" />
//               : category === 'B' ? <Badge className="sub-badge-item" color="#FFFF00" />
//                 : category === 'A' ? <Badge className="sub-badge-item" color="#FF1022" />
//                   : <span className="blank-badge" />
//         } else {
//           categoryIcon = <span className="blank-badge" />
//         }
//         return (
//           <>
//             <div className="col-title">
//               {categoryIcon}
//               {value}
//             </div>
//             <div className="col-desc handle-overflow detail-info">{record.originalItemDescription}</div>
//             <div className="col-desc handle-overflow detail-info">{originalItemDetails}</div>
//           </>
//         )
//       }
//     },
//     //asoh placeholder
//     {},
//     //total orders placeholder
//     {},
//     //total outs placeholder
//     {},
//     // cut off placeholder
//     {},
//   ];
//   const inputRef = useRef();
//   let searchForm = null;
//   let clearFiltersRef = null;
//   let confirmRef = null;
//   // const handleTerritoryParam = (values) => {
//   //   let isCorpProfileUser = false
//   //   if(originalList.length === 0) {
//   //     const user = CORP_USER_LIST.filter(item => item.userId === userId);
//   //     if (!_.isEmpty(user)) {
//   //       isCorpProfileUser = true
//   //     }
//   //   }
//   //   if((bosTerritoryData && ((bosTerritoryData.role && bosTerritoryData.role.toLowerCase() === 'corp') || _.isEmpty(bosTerritoryData.role))) || isCorpProfileUser) {
//   //     let temp = values.territoryInfoList ? values.territoryInfoList.trim() : ''
//   //     if(temp) {
//   //       return [{"terrName": temp}]
//   //     }else {
//   //       return []
//   //     }
//   //   }else {
//   //     return values.territoryInfoList !== undefined && values.territoryInfoList !== null ? uniqueTerritoryList(formatTerrirotyData(values, bosTerritoryData)) : null
//   //   }
//   // }
//   const handleTerritoryParam = (values) => {
//     let isCorpProfileUser = false
//     if (originalList.length === 0) {
//       const user = CORP_USER_LIST.filter(item => item.userId === userId);
//       if (!_.isEmpty(user)) {
//         isCorpProfileUser = true
//       }
//     }
//     if ((bosTerritoryData && ((bosTerritoryData.role && bosTerritoryData.role.toLowerCase() === 'corp') || _.isEmpty(bosTerritoryData.role))) || isCorpProfileUser) {
//       // Fix: Safely handle territoryInfoList regardless of type
//       const territoryValue = values.territoryInfoList;
//       let temp = '';

//       if (territoryValue) {
//         // Convert to string and trim, handling arrays by taking first element
//         if (Array.isArray(territoryValue)) {
//           temp = territoryValue.length > 0 ? String(territoryValue[0]).trim() : '';
//         } else {
//           temp = String(territoryValue).trim();
//         }
//       }

//       if (temp) {
//         return [{ "terrName": temp }]
//       } else {
//         return []
//       }
//     } else {
//       return values.territoryInfoList !== undefined && values.territoryInfoList !== null ? uniqueTerritoryList(formatTerrirotyData(values, bosTerritoryData)) : null
//     }
//   }
//   const handleOriginalItemSearch = (selectedKeys, confirm, dataIndex) => {
//     confirm();
//     setSearchText(selectedKeys[0] ? selectedKeys[0] : storagedCondition?.originalItem);
//     setSearchedColumn(dataIndex);
//     const formVals = searchForm.getFieldsValue()
//     if (formVals && formVals.sites && formVals.sites.length > 0) {
//       saveSearchConditionData({
//         ...formVals,
//         deliveryDate: formVals.deliveryDate !== undefined && formVals.deliveryDate !== null ? parseInt(moment(formVals.deliveryDate).format(COMMON_DATE_FORMAT)) : null,
//         customerNumber: formVals.customerNumber === '' ? null : formVals.customerNumber,
//         territoryInfoList: handleTerritoryParam(formVals),
//       });
//       retainConditionData({ ...conditionData, ...formVals, originalItem: selectedKeys[0] ? selectedKeys[0] : storagedCondition?.originalItem });
//     } else {
//       message.error('Please select Site!')
//     }
//   };
//   const handleOriginalItemReset = (clearFilters, confirm, dataIndex) => {
//     setSearchText('');
//     clearFilters();
//     confirm({
//       closeDropdown: true,
//     });
//     setSearchedColumn(dataIndex);
//     const formVals = searchForm.getFieldsValue()
//     if (formVals && formVals.sites && formVals.sites.length > 0) {
//       saveSearchConditionData({
//         ...formVals,
//         deliveryDate: formVals.deliveryDate !== undefined && formVals.deliveryDate !== null ? parseInt(moment(formVals.deliveryDate).format(COMMON_DATE_FORMAT)) : null,
//         customerNumber: formVals.customerNumber === '' ? null : formVals.customerNumber,
//         territoryInfoList: handleTerritoryParam(formVals),
//       });
//       const condition = { ...conditionData };
//       delete condition.originalItem;
//       retainConditionData({ ...condition });
//     } else {
//       message.error('Please select Site!')
//     }
//   };
//   const originalItemSearchReset = () => {
//     setSearchText('');
//     if (clearFiltersRef) {
//       clearFiltersRef()
//     }
//     if (confirmRef) {
//       confirmRef({
//         closeDropdown: true,
//       });
//     }
//   };
//   const handleInputChg = (setSelectedKeys, e) => {
//     setSelectedKeys(e.target.value ? [e.target.value] : []);
//     retainConditionData({ ...conditionData, originalItem: e.target.value });
//   }
//   const getColumnSearchProps = dataIndex => ({
//     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
//       clearFiltersRef = clearFilters;
//       confirmRef = confirm;
//       return (
//         <div style={{ padding: 8 }}>
//           <Input
//             ref={inputRef}
//             placeholder={`Search ${dataIndex}`}
//             value={selectedKeys[0] || storagedCondition?.originalItem}
//             onChange={e => handleInputChg(setSelectedKeys, e)}
//             onPressEnter={() => handleOriginalItemSearch(selectedKeys, confirm, dataIndex)}
//             style={{ marginBottom: 8, display: 'block' }}
//           />
//           <Space>
//             <Button
//               type="primary"
//               onClick={() => handleOriginalItemSearch(selectedKeys, confirm, dataIndex)}
//               icon={<SearchOutlined />}
//               size="small"
//               style={{ width: 90 }}
//             >
//               Search
//             </Button>
//             <Button onClick={() => handleOriginalItemReset(clearFilters, confirm, dataIndex)} size="small" style={{ width: 90 }}>
//               Reset
//             </Button>
//           </Space>
//         </div>
//       )
//     },
//     filterIcon: filtered => <SearchOutlined style={{ fontSize: '16px', color: filtered || !_.isEmpty(storagedCondition?.originalItem) ? 'blue' : undefined }} />,
//     // onFilter: (value, record) =>{
//     //   return record[dataIndex]
//     //     ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
//     //     : ''
//     // },
//     onFilterDropdownVisibleChange: visible => {
//       if (visible) {
//         setTimeout(() => inputRef.current.select(), 100);
//       }
//     },
//   });
//   const searchFormCb = (form) => {
//     searchForm = form;
//   };
//   const updateToNeverSub = (record) => {
//     const args = {
//       "site": record.site,
//       "siteDesc": record.siteDesc,
//       "nationalId": record.nationalId ? record.nationalId : "",
//       "nationalName": record.nationalName ? record.nationalName : "",
//       "originalItem": record.originalItem,
//       "originalItemDescription": record.originalItemDescription,
//       "originalUom": record.originalItemUom,
//       "originalPack": record.originalItemPack,
//       "originalSize": record.originalItemSize,
//       "originalBrand": record.originalItemBrand,
//       "originalStorageCode": record.originalItemStorageCode,
//       "ruleType": "neversub",
//       "createdByName": auth.user.userName,
//       "createdById": userId,
//       "createTimestamp": moment().format(DATE_TIME_TWO_FORMAT),
//       "modifiedByName": auth.user.userName,
//       "modifiedById": userId,
//       "modifiedTimestamp": moment().format(DATE_TIME_TWO_FORMAT),
//       "endDate": null,
//       "customerNumber": record.customerNumber ? record.customerNumber : "",
//       "customerName": record.customerName ? record.customerName : "",
//       "expandedItems": null,
//       "callFrom": isViewDropOutVisible ? 'dropOuts' : 'outs',
//       "orders": record.orderDetailBeans.map(item => item.orderNumber) || [],
//       "orderLines": record.orderDetailBeans.map(item => item.orderLine) || [],
//       "customerNumbers": record.orderDetailBeans.map(item => item.customerShipTo) || [],
//     }
//     onUpdateSubs(args, null, false, null);
//   }
//   const onUpdateSubs = (formaData, onCloseModal, wasDropout, expandedLength) => {
//     const timing = Date.now();
//     const args = {
//       ...formaData, "customerNumber": formaData.customerNumber ? formaData.customerNumber : "",
//       "customerName": formaData.customerName ? formaData.customerName : "",
//       "nationalId": formaData.nationalId ? formaData.nationalId : "",
//       "nationalName": formaData.nationalName ? formaData.nationalName : "",
//     }
//     updateSubstitutionsData(args).then(data => {
//       if (wasDropout && args.expandedItems != null) {
//         if (expandedLength === null && args.expandedItems.length === 0) {
//           message.success(`Deleted Drop out rule Successfully.`);
//         } else if (expandedLength === null && args.expandedItems.length > 0 && args.dropOutRuleEndDate === undefined) {
//           message.success(`Deleted Drop out rule Successfully.`);
//           message.success(`Updated Substitutions Successfully.`);
//         } else if (expandedLength !== null && args.expandedItems.length >= 0 && args.dropOutRuleEndDate === undefined) {
//           message.success(`Deleted Drop out rule Successfully.`);
//           message.success(`Updated Substitutions Successfully.`);
//         } else {
//           message.success(`Updated Substitutions Successfully.`);
//         }
//       } else {
//         message.success(`Updated Substitutions Successfully.`);
//       }
//       // onCloseModal && onCloseModal();
//       if (searchConditionData) {
//         const formData = {
//           ...searchConditionData,
//           //pageIndex: CONST_PAGINATION_TEN.pageIndex,
//           //pageSize: CONST_PAGINATION_TEN.pageSize,
//           pageIndex: sessionStorage.getItem('pageIndex'),
//           pageSize: sessionStorage.getItem('pageSize'),

//         };
//         if (searchText) {
//           formData.originalItem = searchText
//         }
//         if (isViewDropOutVisible) {
//           resetDropoutsData()
//           fetchDropoutsData(formData)
//         } else {
//           resetOutsData();
//           fetchOutsData(formData);
//         }
//       }
//     }).catch(err => {
//       if (wasDropout && args.expandedItems != null) {
//         if (expandedLength === null && args.expandedItems.length === 0) {
//           message.error(`Delete Drop out Sub rule Failed, please try again.`);
//         } else {
//           if (err.isInvalidShipTo) {
//             message.error(err.message)
//           } else {
//             message.error(`Update Substitutions Failed, please try again.`);
//           }
//         }
//       } else {
//         if (err.isInvalidShipTo) {
//           message.error(err.message)
//         } else if (err?.response?.status === 400) {
//           message.error(err?.response?.data?.description);
//         } else {
//           message.error(`Update Substitutions Failed, please try again.`);
//         }
//       }
//     });
//     datadogRum.onReady(function () {
//       datadogRum.addTiming(`Update Subs`, timing);
//     });
//   }

//   const toggleActionsDropdown = (recordKey) => {
//     setExpandedRows(prevExpandedRows => {
//       const newExpandedRows = new Set();

//       // If the clicked row is not currently expanded, open it (and close all others)
//       if (!prevExpandedRows.has(recordKey)) {
//         newExpandedRows.add(recordKey);
//       }
//       // If the clicked row is already expanded, close it (newExpandedRows remains empty)

//       return newExpandedRows;
//     });
//   };


//   useEffect(() => {
//     if (storagedCondition && storagedCondition?.isViewDropOutVisible) {
//       setViewDropOutModalVisible(storagedCondition?.isViewDropOutVisible);
//     }
//     if (storagedCondition && storagedCondition?.selectedKeys) {
//       setSearchText(storagedCondition?.selectedKeys);
//     }
//   }, [storagedCondition]);

//   //COT-10381: Close Actions dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       // Don't close if clicking on a popconfirm element
//       //COT-10411
//       if (event.target.closest('.ant-popover') ||
//         event.target.closest('.ant-popconfirm')) {
//         return;
//       }

//       // Don't close if clicking inside any dropdown
//       if (event.target.closest('[style*="position: absolute"]')) {
//         return;
//       }//COT-10411
    
//       // Close dropdown when clicking outside
//       if (expandedRows.size > 0) {
//         setExpandedRows(new Set());
//       }
//     };

//     // Add event listener when any dropdown is open
//     if (expandedRows.size > 0) {
//       document.addEventListener('click', handleClickOutside);
//     }

//     // Cleanup event listener
//     return () => {
//       document.removeEventListener('click', handleClickOutside);
//     };
//   }, [expandedRows]);
//   //COT-10381
//   return (
//     <div className="manage-subs-manage-outs">
//       <Spin spinning={exportOutsDataPending}>
//         <div className="chart-title font-size-16-bold" style={{ font: "Myriad Bold" }}>Search Outs</div>
//         {/* defect:cot-5316,when click reload will reset ccc/cst local option as same as search condition */}
//         <SearchFiltersPanel isOnClickRefresh={isOnClickRefresh} searchForm={searchFormCb} originalItemSearchReset={originalItemSearchReset} resetSortedInfo={resetSortedInfo} searchText={searchText} />
//         <div className="flex align-item-center justify-end" style={{ marginBottom: "20px", marginTop: "-45px" }}>


//           {/* COT-10377*/}
//           <div className="action-buttons-container" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//             {/* Reload Button */}
//             <Button
//               type="link"
//               title="Reload"
//               disabled={_.isEmpty(searchConditionData)}
//               onClick={onRefreshOuts}
//               className="action-button reload-button"
//             >
//               <div className="button-content">
//                 <FontAwesomeIcon
//                   icon={faArrowsRotate}
//                   color={_.isEmpty(searchConditionData) ? "#a1a1a2" : "#6b6b6c"}
//                   style={{ height: "15px", width: "15px" }}
//                 />
//                 <span className="button-label">Reload</span>
//               </div>
//             </Button>

//             {/* View Drop Outs Button */}
//             <Button
//               type="link"
//               title="View Drop Outs"
//               disabled={_.isEmpty(searchConditionData)}
//               onClick={handleViewDropouts}
//               className="action-button view-dropouts-button"
//             >
//               <div className="button-content">
//                 <FontAwesomeIcon
//                   icon={faEye}
//                   color={_.isEmpty(searchConditionData) && !storagedCondition?.isViewDropOutVisible ? "#a1a1a2" : (isViewDropOutVisible ? "#40a9ff" : "#6b6b6c")}
//                   style={{ height: "15px", width: "15px" }}
//                 />
//                 <span className="button-label">View Drop Outs</span>
//               </div>
//             </Button>

//             {/* Settings Button - Only for mobile phones, not tablets */}
//             {!isTablet && (
//               <Button
//                 ref={settingsButtonRef}
//                 type="link"
//                 title="Settings"
//                 onClick={handleSettingsClick}
//                 className="action-button settings-button"
//               >
//                 <span className="settings-icon">
//                   <FontAwesomeIcon
//                     icon={faGears}
//                     style={{ color: '#ffffff', fontSize: '17px', transform: 'rotate(95deg)' }}
//                   />
//                 </span>
//               </Button>
//             )}

//             {/* Export Button - Only for tablets */}
//             {isTablet && (
//               <Button
//                 type="link"
//                 title={exportOutsDataPending ? 'Exporting...' : "Export"}
//                 disabled={_.isEmpty(searchConditionData) || exportOutsDataPending}
//                 onClick={onExportOuts}
//                 className="action-button export-button"
//               >
//                 <div className="button-content">
//                   <FontAwesomeIcon
//                     icon={faFileExport}
//                     color={_.isEmpty(searchConditionData) ? "#a1a1a2" : "#6b6b6c"}
//                     style={{ height: "15px", width: "15px" }}
//                   />
//                   <span className="button-label">Export</span>
//                 </div>
//               </Button>
//             )}
//           </div>
//         </div>
//         <CommonTable
//           //defect:COT-5293、5294、5295, help Melody to commit
//           rowKey={record => `${record.uid}-${record.site}-${record.nationalId}-${record.customerNumber}-${record.originalItem}-${record.originalItemUom}`}
//           //columns={outsParentColumns}
//           columns={getFilteredColumns()}
//           tableClassName={outsData || dropoutsData ? "outs-report-table" : ""}
//           datasource={isViewDropOutVisible ? dropoutsData : outsData}
//           loadingData={fetchOutsDataPending || checkOutsLockPending || updateOutsRecordLockPending || removeDropOutsPending ||
//             fetchDropoutsDataPending || removeAllocatedItemPending || allocateOriginalItemPending}
//           paginationStyle={{ textAlign: "right", margin: '16px 0px' }}
//           triggerConditions={searchConditionData}
//           searchText={searchText}
//           onFecthData={isViewDropOutVisible ? fetchDropoutsData : fetchOutsData}
//           onResetStore={isViewDropOutVisible ? resetDropoutsData : resetOutsData}
//           //scrollStyle={{ x: 'max-content', y: 300 }}
//           scrollStyle={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
//           paginationSetting={CONST_PAGINATION_TEN}
//           //paginationSetting={pagination}
//           key={location.pathname}
//           isManageOuts={true}
//           isdropout={isViewDropOutVisible ? "yes" : null}
//           isRefreshed={isOnClickRefresh}
//           onOutsTableChange={handleTableChange}
//           // optimizationEnable={optimizationEnable}
//           sorting={sortedInfo}
//         />
//         {isOrderDetailModalVisible && renderOrderDetailModal}
//         {isInventoryDetailModalVisible && renderInventoryDetailModal}
//         {isAddSubModalVisible && renderAddSubModal}
//         {isLockedWarningModalVisible && renderLockedWarningModal}
//         {isAsohAvailableWarningVisible && renderAllocateOriginaItemlWarningModal}
//         {isReasonCodeHint && renderReasonCodeHintModal}
//         {isDropOutResonVisible && renderDropOutResonModal}
//       </Spin>

//       {isColumnSelectionVisible && (
//         <ColumnSelectionModal
//           isVisible={isColumnSelectionVisible}
//           onClose={() => setColumnSelectionVisible(false)}
//           isViewDropOutVisible={isViewDropOutVisible}
//           isManageOutsScreen={true}
//           baseColumns={getAllColumnsForModal()}
//           visibleColumns={visibleColumns}
//           onColumnChange={handleColumnChange}
//           triggerElement={settingsButtonRef.current} // Pass the button element
//         />
//       )}
//     </div>
//   );
// };


import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import { SettingOutlined, Button, Badge, message, Spin, Input, Space, notification, Switch, Popconfirm } from 'antd';
import { renderTableColumns } from '../../common/renderColumns';
import { DropOutReasonModal, SearchFiltersPanel } from './';
import moment from 'moment';
import { SLASH_DATE_FORMAT } from '../../common/constants';
import { CommonTable } from '../common';
import ColumnSelectionModal from './ColumnSelectionModal';

import { useResponsive } from './useResponsive';

import {
  useFetchOutsData, useFetchDropoutsData, useFetchInventoryData, useResetOutsData, useResetDropoutsData,
  useExportOutsData, useResetOrderDetailData, useResetInventoryDetailData, useFetchRecommendedProducts, useResetRecommendedProducts,
  useResetSubstituteProducts, useRemoveDropOuts, useRemoveAllocatedItem, useAllocateOriginalItem, useCheckOutsLock, useUpdateOutsRecordLock,
  useSaveSearchConditionData, useSaveOrderDetailData, useAlerts, useFetchBosTerritoryData, useUpdateSubstitutionsData,
} from './redux/hooks';
// import { useFetchTerritoryData } from '../dashboard/redux/hooks';
import ManageOutsOperateModalMobile from './ManageOutsOperateModalMobile';
import ManageOutsOperateModal from './ManageOutsOperateModal';
import ManageOutsAddSubMobile from './ManageOutsAddSubMobile';
import { CONST_PAGINATION_TEN, COMMON_DATE_FORMAT, DATE_TIME_TWO_FORMAT, BOS_SEARCH_CONDITION_KEY, SIA_TEST_USER_ID_KEY, BOS_TERRITORY_DATA_KEY } from '../../common/constants';
import ManageOutsWarningModal from './ManageOutsWarningModal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faArrowsRotate, faEye, faGears } from '@fortawesome/free-solid-svg-icons';
import { CartIcon, EditIcon, DropIcon } from '../common/CustomerIcons';
import { SearchOutlined, StopOutlined, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { uniqueTerritoryList } from './getOriginalSelectedList';
import { formatTerrirotyData } from './formattedSearchCondition';
import { CONST_DROP_OUT_CST_FLAG_FROM_CCC, CONST_ROLE_OPTIONS_CCC, CONST_ROLE_OPTIONS_CST } from '../../common/manageOutsConstants';
import { CORP_USER_LIST } from '../../common/corpProfile';
import { datadogRum } from '@datadog/browser-rum';
import { validateGroupIdRegExp } from './formattedSubsData';
import { useRetainConditionData } from './redux/hooks';
import { CustomerTitle } from './OgmSubs';

export default function ManageOutsMobile() {
  const {
    outsData,
    orderDetail,
    fetchOutsDataPending,
    dropoutsData,
    fetchDropoutsDataPending,
    searchConditionData,
    exportOutsDataPending,
    checkOutsLockPending,
    updateOutsRecordLockPending,
    removeDropOutsPending,
    removeAllocatedItemPending,
    allocateOriginalItemPending,
    bosTerritory,
    originalList,
    userId,
    conditionData,
  } = useSelector(state => ({
    outsData: state.manageSubs.outsData,
    orderDetail: state.manageSubs.orderDetail,
    fetchOutsDataPending: state.manageSubs.fetchOutsDataPending,
    dropoutsData: state.manageSubs.dropoutsData,
    fetchDropoutsDataPending: state.manageSubs.fetchDropoutsDataPending,
    searchConditionData: state.manageSubs.searchConditionData,
    exportOutsDataPending: state.manageSubs.exportOutsDataPending,
    checkOutsLockPending: state.manageSubs.checkOutsLockPending,
    updateOutsRecordLockPending: state.manageSubs.updateOutsRecordLockPending,
    removeDropOutsPending: state.manageSubs.removeDropOutsPending,
    removeAllocatedItemPending: state.manageSubs.removeAllocatedItemPending,
    allocateOriginalItemPending: state.manageSubs.allocateOriginalItemPending,
    bosTerritory: state.manageSubs.bosTerritoryData,
    originalList: state.manageSubs.originalList,
    userId: state.home.auth.user.userId,
    conditionData: state.manageSubs.conditionData,
  }));

  const { auth } = useSelector(state => ({
    auth: state.home.auth,
  }));
  const { fetchBosTerritoryData } = useFetchBosTerritoryData();
  const { fetchOutsData } = useFetchOutsData();
  const { fetchDropoutsData } = useFetchDropoutsData();
  const { fetchInventoryData } = useFetchInventoryData();
  const { resetOutsData } = useResetOutsData();
  const { resetDropoutsData } = useResetDropoutsData();
  const { exportOutsData } = useExportOutsData();
  const { resetOrderDetailData } = useResetOrderDetailData();
  const { resetInventoryDetailData } = useResetInventoryDetailData();
  const { fetchRecommendedProducts } = useFetchRecommendedProducts();
  const { resetRecommendedProducts } = useResetRecommendedProducts();
  const { resetSubstituteProducts } = useResetSubstituteProducts();
  const { removeDropOuts } = useRemoveDropOuts();
  const { alerts } = useAlerts();
  const { removeAllocatedItem } = useRemoveAllocatedItem();
  const { allocateOriginalItem } = useAllocateOriginalItem();
  const { checkOutsLock } = useCheckOutsLock();
  const { updateOutsRecordLock } = useUpdateOutsRecordLock();
  const { saveOrderDetailData } = useSaveOrderDetailData();
  const { retainConditionData } = useRetainConditionData();
  const [isOrderDetailModalVisible, setOrderDetailModalVisible] = useState(false);
  const [isInventoryDetailModalVisible, setInventoryDetailModalVisible] = useState(false);
  //viewdropout
  const [isViewDropOutVisible, setViewDropOutModalVisible] = useState(false);
  const [isAddSubModalVisible, setAddSubModalVisible] = useState(false);
  const [isLockedWarningModalVisible, setLockedWarningModalVisible] = useState(false);
  const [sorting, setSorting] = useState({ sort: 'descend', sortedBy: 'orderNumber' });
  const [baseData, setBaseData] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isAsohAvailableWarningVisible, setAsohAvailableWarningVisible] = useState(false);
  const [isOnClickRefresh, setOnClickRefresh] = useState(false);

  const { saveSearchConditionData } = useSaveSearchConditionData();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [isDropOutResonVisible, setDropOutReasonVisible] = useState(false);
  const [dropOutRecord, setDropOutRecord] = useState(null);
  const [dropOutReason, setDropOutReason] = useState("DR001");
  const [isReasonCodeHint, setReasonCodeHint] = useState(false)
  const [allocatedRecord, setAllocatedRecord] = useState(null)
  const { updateSubstitutionsData } = useUpdateSubstitutionsData();
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [isColumnSelectionVisible, setColumnSelectionVisible] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState([
    'site',
    'nationalId',
    'originalItem',
    'asoh',
    'totalOrders',
    //'totalOuts',  // Add this from desktop version
    //'cutoff',     // Add this from desktop version 
    'ruleType'    // Actions column
  ]);
  // const [optimizationEnable,setOptimizationEnable] = useState(true);  //COT-8330
  const location = useLocation();
  const settingsButtonRef = useRef(null);
  const [isTablet, setIsTablet] = useState(false);

  // Detect tablet vs mobile phone
  useEffect(() => {
    const checkIsTablet = () => {
      setIsTablet(window.innerWidth >= 600 && window.innerWidth <= 800);
    };
    checkIsTablet();
    window.addEventListener('resize', checkIsTablet);
    return () => window.removeEventListener('resize', checkIsTablet);
  }, []);

  let storagedCondition = JSON.parse(sessionStorage.getItem(BOS_SEARCH_CONDITION_KEY));
  const bosTerritoryData = JSON.parse(sessionStorage.getItem(BOS_TERRITORY_DATA_KEY));
  useEffect(() => {
    if (storagedCondition) {
      setSearchText(storagedCondition?.originalItem);
    }
  }, [storagedCondition]);
  const [sortedInfo, setSortedInfo] = useState({  //COT-10012,customerized sorter, promote sorting to parent component, so change the state
    sort: 'ascend',
    sortedBy: 'cutoff',
  });

  // useEffect(() => {
  //   let sessionUserId = sessionStorage.getItem(SIA_TEST_USER_ID_KEY);
  //   let userId = auth.user.userId;
  //   if (!_.isEmpty(sessionUserId)) {
  //     if (sessionUserId !== userId) {
  //       userId = sessionUserId;
  //     }
  //   }
  //   fetchBosTerritoryData({ userId, "isSpecial": true });
  // }, []);//eslint-disable-line

  useEffect(() => {
  if (!auth.user.userId) return;
  let sessionUserId = sessionStorage.getItem(SIA_TEST_USER_ID_KEY);
  let userId = auth.user.userId;
  if(!_.isEmpty(sessionUserId)){
    if(sessionUserId !== userId){
      userId = sessionUserId; 
    }
  }
  fetchBosTerritoryData({userId, "isSpecial": true});
},[auth.user.userId]);//eslint-disable-line

  useEffect(() => {
    if (isViewDropOutVisible) {
      // Add End Date column when viewing dropouts
      setVisibleColumns(prev => {
        if (!prev.includes('endDate')) {
          // Insert endDate before ruleType (Actions)
          const newColumns = [...prev];
          const actionsIndex = newColumns.indexOf('ruleType');
          if (actionsIndex > -1) {
            newColumns.splice(actionsIndex, 0, 'endDate');
          } else {
            newColumns.push('endDate');
          }
          return newColumns;
        }
        return prev;
      });
    } else {
      // Remove End Date column when viewing regular outs
      setVisibleColumns(prev => prev.filter(col => col !== 'endDate'));
    }
  }, [isViewDropOutVisible]);

  const handleViewDropouts = () => {
    const newViewState = !isViewDropOutVisible;
    setViewDropOutModalVisible(newViewState);
    retainConditionData({ ...conditionData, isViewDropOutVisible: newViewState });
  };

  const handleColumnChange = (newVisibleColumns) => {
    setVisibleColumns(newVisibleColumns);
    sessionStorage.setItem('manageOutsVisibleColumns', JSON.stringify(newVisibleColumns));
  };

  // Add this function to handle gear button click
  const handleSettingsClick = () => {
    setColumnSelectionVisible(true);
  };

  // Add this useEffect to load saved column preferences
  useEffect(() => {
    const savedColumns = sessionStorage.getItem('manageOutsVisibleColumns');
    if (savedColumns) {
      const parsed = JSON.parse(savedColumns);
      // Ensure Actions column is always included
      const columnsWithActions = [...new Set([...parsed, 'ruleType'])];
      setVisibleColumns(columnsWithActions);
    }
  }, []);
  const END_DATE_COLUMN = {
    title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='endDate' title='End Date' />,
    dataIndex: 'endDate',
    width: 110,
    blankWidth: 110,
    sortOrder: sortedInfo.sortedBy === 'endDate' ? sortedInfo.sort : null,
    render: value => value ? moment(value).format(SLASH_DATE_FORMAT) : '',
  };
  const onTableChange = (page, filters, sorter) => {
    const sort =
      Object.keys(sorter).length > 0 && sorter.order !== undefined
        ? {
          sortedBy: sorter.field,
          sort: sorter.order,
        }
        : {
          sortedBy: 'orderNumber',
          sort: 'descend',
        };
    setSorting(sort);
    const formData = {
      orderDetail,
      ...sort,
    }
    saveOrderDetailData(formData);
  };
  const onToggleModal = updateState => {
    updateState(prevState => {
      return !prevState;
    });
  }
  const onExportOuts = () => {
    const params = { ...searchConditionData }
    if (searchText) {
      params.originalItem = searchText
    }
    params.callFrom = isViewDropOutVisible ? 'dropOuts' : 'outs'
    params.optimizationEnable = true;   //COT-8330,If remove optimization toggle,need hardcode optimizationEnable for export api
    const context = datadogRum.getGlobalContext('BosView');
    const timing = Date.now();
    exportOutsData(params);
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Export ${context.BosView.screen} data`, timing);
    });
  }
  const onRefreshOuts = () => {


    // if(searchConditionData) {
    //   const formData = {
    //     ...searchConditionData,
    //     pageIndex: CONST_PAGINATION_TEN.pageIndex,
    //     pageSize: CONST_PAGINATION_TEN.pageSize,
    //    // ...outsSortingForRefresh
    //   };
    //   if(searchText) {
    //     formData.originalItem = searchText
    //   }
    //   if(isViewDropOutVisible) {
    //     fetchDropoutsData(formData);
    //   }else {
    //     fetchOutsData(formData);
    //   }
    //defect:cot-5316,when click reload will reset ccc/cst local option as same as search condition
    setOnClickRefresh(!isOnClickRefresh);
    // }
  }
  //defect: order detail re-design
  const handleViewOrderDetail = (record) => {
    saveOrderDetailData({ orderDetail: record.orderDetailBeans });
    onToggleModal(setOrderDetailModalVisible);
  }
  const handleViewInventoryDetail = (record) => {
    let inventoryCondition = {
      // products: [
      //   {
      //     supc: record.originalItem,
      //     splitFlag: false,
      //   }
      // ],
      // businessUnitNumber: record.site,
      site: record.site,
      conceptId: !_.isEmpty(record.nationalId) ? record.nationalId : record.customerNumber,
      originalItem: record.originalItem
    }
    const timing = Date.now();
    fetchInventoryData(inventoryCondition);
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Fetch inventory`, timing);
    });
    onToggleModal(setInventoryDetailModalVisible);
  }

  const handleCheckOutsLock = (record) => {
    setSelectedRecord(record);
    const formData = {
      site: record.site,
      itemNumber: record.originalItem,
      orders: record.orderNumbers
    }
    checkOutsLock(formData).then((response) => {
      if (response && response[0].recordLockFlag === 'Y') {
        onToggleModal(setLockedWarningModalVisible);
      } else {
        handleAddSub(record);
      }
    }, (err) => {
      message.destroy();
      message.error(err);
    })
  }
  const handleUpdateOutsRecordLock = (record) => {
    const formData = {
      site: record.site,
      itemNumber: record.originalItem,
      recordLockFlag: !isAddSubModalVisible ? 'Y' : 'N',
      orders: record.orderNumbers
    }
    updateOutsRecordLock(formData).then((response) => {
    }, (err) => {
      message.error(`Update Outs Record Lock Failed, please try again.`);
    });
  }
  //COT-8253:UI-Ability for CCC Agents to Select Reason for Dropped Items
  const handleRemoveDropOut = (record) => {
    if (record) {
      const nowTime = moment().format(DATE_TIME_TWO_FORMAT)
      let formData = {
        site: record.site,
        siteDesc: record.siteDesc,
        originalItem: record.originalItem,
        originalBrand: record.originalItemBrand,
        // originalItemCategory
        originalItemDescription: record.originalItemDescription,
        originalPack: record.originalItemPack,
        originalSize: record.originalItemSize,
        // originalSplitIndicator
        originalStorageCode: record.originalItemStorageCode,
        originalUom: record.originalItemUom,
        orders: record.orderDetailBeans.map(item => item.orderNumber),
        orderLines: record.orderDetailBeans.map(item => item.orderLine),
        customerNumbers: record.orderDetailBeans.map(item => item.customerShipTo),
        nationalId: record.nationalId ? record.nationalId : "",
        nationalName: record.nationalName ? record.nationalName : "",
        customerNumber: record.customerNumber ? record.customerNumber : "",
        customerName: record.customerName ? record.customerName : "",
        createdById: auth.user.userId,
        createdByName: auth.user.userName,
        createTimestamp: nowTime,
        modifiedById: auth.user.userId,
        modifiedByName: auth.user.userName,
        modifiedTimestamp: nowTime,
        // endDate: (searchConditionData.deliveryDate + '').replace(/^(\d{4})(\d{2})(\d{2})$/, "$2/$3/$1"),
        endDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
      };
      if (searchConditionData && searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC && !_.isEmpty(record.categorizationFlag)) {
        formData = { ...formData, dropFlag: CONST_DROP_OUT_CST_FLAG_FROM_CCC }
      }
      if (searchConditionData && searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC) {
        formData = { ...formData, dropOutReason: dropOutReason, managedBy: 'CCC' }
      }
      removeDropOuts(formData)
        .then(
          response => {
            resetOutsData();
            if (
              searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC ||
              searchConditionData.managedBy === CONST_ROLE_OPTIONS_CST
            ) {
              //Alerts API
              const data = [];
              for (let order of record.orderDetailBeans) {
                const formData = {
                  nationalCustomerId: record.nationalId ? record.nationalId : '',
                  createdByUserId: auth.user.userId ? auth.user.userId : '',
                  createdDate: moment().format('MM/DD/YYYY'),
                  customerNumber: order.customerShipTo,
                  modifiedByUserId: auth.user.userId ? auth.user.userId : '',
                  modifiedDate: moment().format('MM/DD/YYYY'),
                  orderDetailLineNumber: order.orderLine,
                  orderNumber: order.orderNumber,
                  originalItem: record.originalItem,
                  opcoNumber: record.site,
                  substituteItemNumber: '',
                  substituteQuantity: '',
                  splitCode: '',
                  salesForceId: '',
                  managedBy: searchConditionData.managedBy,
                  category: record.categorizationFlag,
                  alertType: '',
                  batchIdType: '',
                  dropDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
                };
                data.push(formData);
              }
              alerts(data);
            }
            const params = { ...searchConditionData };
            if (searchText) {
              params.originalItem = searchText;
            }
            fetchOutsData({ ...params });
            message.info('Drop Outs Successfully.');
          },
          err => {
            message.destroy();
            message.error(`Drop Outs Failed, please try again.`);
          },
        )
        .finally(() => {
          cancelReasonModal();
        });
    }
  }
  const cancelReasonModal = () => {
    onToggleModal(setDropOutReasonVisible);
    updateOutsRecordLock({
      site: dropOutRecord.site,
      itemNumber: dropOutRecord.originalItem,
      recordLockFlag: 'N',
      orders: dropOutRecord.orderNumbers,
    }).then(
      response => { },
      err => { message.error(`Update Outs Record Lock Failed, please try again.`); },
    );
  };
  const handleDropOuts = (record) => {
    const timing = Date.now();
    const lockData = {
      site: record.site,
      itemNumber: record.originalItem,
      orders: record.orderNumbers,
    }
    checkOutsLock(lockData).then((response) => {
      if (response && response[0].recordLockFlag === 'Y') {
        onToggleModal(setLockedWarningModalVisible);
      } else {
        //COT-8253:BOS 2.0 - UI-Ability for CCC Agents to Select Reason for Dropped Items
        if (searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC) {
          setDropOutRecord(record);
          onToggleModal(setDropOutReasonVisible);
          updateOutsRecordLock({
            site: record.site,
            itemNumber: record.originalItem,
            recordLockFlag: 'Y',
            orders: record.orderNumbers,
          }).then((response) => { }, (err) => {
            message.error(`Update Outs Record Lock Failed, please try again.`);
          });
        } else {
          const nowTime = moment().format(DATE_TIME_TWO_FORMAT)
          let formData = {
            site: record.site,
            siteDesc: record.siteDesc,
            originalItem: record.originalItem,
            originalBrand: record.originalItemBrand,
            // originalItemCategory
            originalItemDescription: record.originalItemDescription,
            originalPack: record.originalItemPack,
            originalSize: record.originalItemSize,
            // originalSplitIndicator
            originalStorageCode: record.originalItemStorageCode,
            originalUom: record.originalItemUom,
            orders: record.orderDetailBeans.map(item => item.orderNumber),
            orderLines: record.orderDetailBeans.map(item => item.orderLine),
            customerNumbers: record.orderDetailBeans.map(item => item.customerShipTo),
            nationalId: record.nationalId ? record.nationalId : "",
            nationalName: record.nationalName ? record.nationalName : "",
            customerNumber: record.customerNumber ? record.customerNumber : "",
            customerName: record.customerName ? record.customerName : "",
            createdById: auth.user.userId,
            createdByName: auth.user.userName,
            createTimestamp: nowTime,
            modifiedById: auth.user.userId,
            modifiedByName: auth.user.userName,
            modifiedTimestamp: nowTime,
            // endDate: (searchConditionData.deliveryDate + '').replace(/^(\d{4})(\d{2})(\d{2})$/, "$2/$3/$1"),
            endDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
            //COT-8253:BOS 2.0 - UI-Ability for CCC Agents to Select Reason for Dropped Items
            dropOutReason: null,
            managedBy: searchConditionData.managedBy,
          };
          if (searchConditionData && searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC && !_.isEmpty(record.categorizationFlag)) {
            formData = { ...formData, dropFlag: CONST_DROP_OUT_CST_FLAG_FROM_CCC }
          }
          updateOutsRecordLock({
            site: record.site,
            itemNumber: record.originalItem,
            recordLockFlag: 'Y',
            orders: record.orderNumbers,
          }).then((response) => {

            removeDropOuts(formData).then((response) => {
              resetOutsData();
              if (searchConditionData.managedBy === CONST_ROLE_OPTIONS_CCC || searchConditionData.managedBy === CONST_ROLE_OPTIONS_CST) {
                //Alerts API
                const data = [];
                for (let order of record.orderDetailBeans) {
                  const formData = {
                    nationalCustomerId: record.nationalId ? record.nationalId : "",
                    createdByUserId: auth.user.userId ? auth.user.userId : "",
                    createdDate: moment().format("MM/DD/YYYY"),
                    customerNumber: order.customerShipTo,
                    modifiedByUserId: auth.user.userId ? auth.user.userId : "",
                    modifiedDate: moment().format("MM/DD/YYYY"),
                    orderDetailLineNumber: order.orderLine,
                    orderNumber: order.orderNumber,
                    originalItem: record.originalItem,
                    opcoNumber: record.site,
                    substituteItemNumber: "",
                    substituteQuantity: "",
                    splitCode: "",
                    salesForceId: "",
                    managedBy: searchConditionData.managedBy,
                    category: record.categorizationFlag,
                    alertType: "",
                    batchIdType: "",
                    dropDate: document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,

                  }
                  data.push(formData);
                }

                alerts(data);


              }
              const params = { ...searchConditionData }
              if (searchText) {
                params.originalItem = searchText
              }
              fetchOutsData(params);
              message.info('Drop Outs Successfully.');
            },
              (err) => {
                message.destroy();
                message.error(`Drop Outs Failed, please try again.`);
              });
          }).catch((err) => {
            message.error(`Update Outs Record Lock Failed, please try again.`);
          }).finally(() => {
            updateOutsRecordLock({
              site: record.site,
              itemNumber: record.originalItem,
              recordLockFlag: 'N',
              orders: record.orderNumbers,
            })
          });
        }
      }
    }, (err) => {
      message.destroy();
      message.error(err);
    })
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Drop outs`, timing);
    });
  }
  const handleAddSub = (record) => {
    //COT-7911,If Substitute from dropOuts page need pass orderLines parameter in updateSubstitutionsData api
    let orderNumbers = [];
    let orderLines = [];
    let customerNumbers = [];
    for (let order of record.orderDetailBeans) {
      orderNumbers.push(String(order.orderNumber));
      orderLines.push(order.orderLine);
      // if(validateGroupIdRegExp(record.nationalId)){
      customerNumbers.push(order.customerShipTo);
      // }
    }
    setBaseData({
      "site": record.site,
      "siteDesc": record.siteDesc,
      "nationalId": record.nationalId,
      "nationalName": record.nationalName,
      "customerNumber": record.customerNumber,
      "customerName": record.customerName,
      "conceptId": record.nationalId ? record.nationalId : record.customerNumber,
      "conceptName": record.nationalName ? record.nationalName : record.customerName,
      "originalItem": record.originalItem,
      "originalItemDescription": record.originalItemDescription,
      "originalItemUom": record.originalItemUom,
      "originalPack": record.originalItemPack,
      "originalSize": record.originalItemSize,
      "kosher": record.kosher,//COT-5366 show original item kosher
      "originalBrand": record.originalItemBrand,
      "originalStorageCode": record.originalItemStorageCode,
      "casePrice": '---',
      "caseQuantity": record.asoh,
      "isFromOuts": true,
      "orderNumbers": orderNumbers, //COT-7911,If Substitute from dropOuts page need pass orderLines parameter in updateSubstitutionsData api
      "orderLines": orderLines, //COT-7911,If Substitute from dropOuts page need pass orderLines parameter in updateSubstitutionsData api
      "deliveryDate": document.getElementById('manage-subs-filter-form-mobile_deliveryDate').value,
      "totalOuts": record.totalOuts,
      "searchText": searchText,
      "callFrom": isViewDropOutVisible ? 'dropOuts' : 'outs',
      "customerNumbers": customerNumbers,
    })
    const timing = Date.now();
    fetchRecommendedProducts({
      "searchBy": "Item Description",
      "searchInput": record.originalItemDescription,
      "site": [record.site],
      "originalItemUom": record.originalItemUom,
      "originalItem": record.originalItem,
      "nationalId": record.nationalId,
      "customerNumber": record.customerNumber,
      "isFromOuts": true,
      "totalOuts": record.totalOuts,
      "searchFor":"Recommended Products",
    })
      .catch(err => {
        //message.error(`Search Recommended Substitutions Failed, please try again.`);
        message.error(`${err}`); //COT-10152
      });
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Fetch Recommended Products`, timing);
    });
    onToggleModal(setAddSubModalVisible);
    handleUpdateOutsRecordLock(record);
  }
  const resetOrderDetail = () => {
    resetOrderDetailData();
  }
  const resetInventoryData = () => {
    resetInventoryDetailData();
  }
  const handleAllocateOriginalItem = (record) => {
    setAllocatedRecord(record)
    const lockData = {
      site: record.site,
      itemNumber: record.originalItem,
      orders: record.orderNumbers,
    }

    checkOutsLock(lockData).then((response) => {
      if (response && response[0].recordLockFlag === 'Y') {
        onToggleModal(setLockedWarningModalVisible);
      } else {
        if (record.asoh < record.totalOuts) {
          onToggleModal(setAsohAvailableWarningVisible);
        } else {
          onToggleModal(setReasonCodeHint);
        }
      }
    }, (err) => {
      message.destroy();
      message.error(err);
    })
  }

  const CONST_OUTS_TABLE_COLUMNS = [
    {
      title: 'Site ID',
      dataIndex: 'site',
      width: 100,
      blankWidth: 100,
      // sorter: true,
      render: false,
      extendRender: true,
      onCell: (record, rowIndex) => {
        if (record.requestApprovalFlag) {
          return {
            style: {
              borderLeft: 'solid 3px #ff0000'
            }
          }
        } else {
          return {}
        }
      },
    },
    {
      // title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='nationalId' title='Group/Ship To'/>,
      title: 'Group/Ship To',
      dataIndex: 'nationalId',
      width: 140,
      blankWidth: 140,
      // sorter: true,  //defect:COT-5601,Manage Outs - The sorting indicator in the columns remains highlighted on reloading the data in Manage Outs page
      render: false,
      extendRender: true,
      //sortOrder: sortedInfo.sortedBy === 'nationalId' ? sortedInfo.sort : null,
    },
    {
      //title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='originalItem' title='Original Item'/>,
      title: 'Original Item',
      dataIndex: 'originalItem',
      width: 190,
      blankWidth: 190,
      // sorter: true,
      sortOrder: sortedInfo.columnKey === 'originalItem' ? sortedInfo.order : null,
      render: false,
      extendRender: true,
    },
    {
      title: 'ASOH',
      dataIndex: 'asoh',
      width: 70,
      blankWidth: 70,
      // sorter: true,
      render: false,
      render: (text, record) =>renderCellAsoh(text,record)
    },
    {
      title: 'Total Orders',
      dataIndex: 'totalOrders',
      width: 100,
      blankWidth: 100,
      // sorter: true,
      render: false,
      render: (text, record) =>renderCellTotalOrders(text,record)
    },
    // {
    //   title: 'Total Outs',
    //   dataIndex: 'totalOuts',
    //   width: 90,
    //   blankWidth: 90,
    //   // sorter: true,
    //   render: false,
    // },
    // {
    //   title: <CustomerTitle setSorting={setSortedInfo} sorting={sortedInfo} dataIndex='cutoff' title='Cutoff'/>,
    //   dataIndex: 'cutoff',
    //   width: 70,
    //   blankWidth: 70,
    //   // sorter: true,
    //   sortOrder: sortedInfo.sortedBy === 'cutoff' ? sortedInfo.sort : null,
    //   render: false,
    // },
    //COT-10373 EndDate column for View Dropouts page
    {
      title: 'End Date', // Add the End Date column
      dataIndex: 'endDate',
      width: 110,
      blankWidth: 110,
      render: value => value ? moment(value).format(SLASH_DATE_FORMAT) : '',
    },// EndDate column for View Dropouts page
  ];
  const buildColumnsForTable = () => {
    // First, apply search props to the original item column
    const columnsWithSearch = [...CONST_OUTS_TABLE_COLUMNS];
    const originalItemColumnIndex = columnsWithSearch.findIndex(col => col.dataIndex === 'originalItem');

    if (originalItemColumnIndex !== -1) {
      columnsWithSearch[originalItemColumnIndex] = {
        ...columnsWithSearch[originalItemColumnIndex],
        ...getColumnSearchProps('originalItem')
      };
    }

    // Then render the columns using renderTableColumns
    let baseColumns = renderTableColumns(columnsWithSearch, null, renderOutsParentElement);


    //COT-10373 EndDate column for View Dropouts page
    // Find index of Cutoff column for conditional End Date insertion
    const cutoffIdx = baseColumns.findIndex(col => col.dataIndex === 'cutoff');
    //COT-10373 EndDate column for View Dropouts page

    //   // Conditionally insert End Date column for View DropOut page
    //   if (isViewDropOutVisible && cutoffIdx !== -1) {
    //     baseColumns.splice(cutoffIdx + 1, 0, END_DATE_COLUMN);
    //   }

    // Add Actions column
    const actionsColumn = {
      title: 'Actions',
      dataIndex: 'ruleType',
      width: 60,
      blankWidth: 60,
      fixed: 'right',
      render: (value, record) => {
        const recordKey = `${record.uid}-${record.site}-${record.nationalId}-${record.customerNumber}-${record.originalItem}-${record.originalItemUom}`;
        const isExpanded = expandedRows.has(recordKey);

        return (
          <div style={{ position: 'relative' }}>
            <Button
              type="link"
              onClick={() => toggleActionsDropdown(recordKey)}
              style={{
                padding: '4px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {isExpanded ? (
                <CaretUpOutlined style={{ fontSize: '12px', color: '#6b6b6c' }} />
              ) : (
                <CaretDownOutlined style={{ fontSize: '12px', color: '#6b6b6c' }} />
              )}
            </Button>

            {isExpanded && (
              <div
                style={{
                  position: 'absolute',
                  top: '85%',
                  right: '52px',
                  background: '#fff',
                  border: '1px solid #d9d9d9',
                  borderRadius: '6px',
                  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                  zIndex: 99999,
                  padding: '8px 0',
                  minWidth: '190px',
                  width: '190px',
                  marginTop: '-20px'
                }}
              >
                {/* Your existing dropdown content */}
                <div
                  onClick={() => {
                    handleCheckOutsLock(record);
                    setExpandedRows(new Set());
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <span style={{
                    fontSize: '12px',
                    color: '#333',
                    fontWeight: '400',
                    width: '130px',
                    textAlign: 'left',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                    Search for Sub
                  </span>
                  <div style={{
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <EditIcon style={{ fontSize: '16px', color: '#6b6b6c' }} />
                  </div>
                </div>

                {/* Include all your other action items */}
                <div style={{ height: '1px', background: '#e8e8e8', margin: '0 8px' }}></div>

                {!isViewDropOutVisible && (
                  <>
                    <div
                      onClick={() => {
                        handleDropOuts(record);
                        setExpandedRows(new Set());
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '12px 16px',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <span style={{
                        fontSize: '12px',
                        color: '#333',
                        fontWeight: '400',
                        width: '130px',
                        textAlign: 'left',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}>
                        Drop Out
                      </span>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}>
                        <DropIcon style={{ fontSize: '16px', color: '#6b6b6c' }} />
                      </div>
                    </div>
                    <div style={{ height: '1px', background: '#e8e8e8', margin: '0 8px' }}></div>
                  </>
                )}

                <div
                  onClick={() => {
                    handleAllocateOriginalItem(record);
                    setExpandedRows(new Set());
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <span style={{
                    fontSize: '12px',
                    color: '#333',
                    fontWeight: '400',
                    width: '130px',
                    textAlign: 'left',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                    Allocate Original Item
                  </span>
                  <div style={{
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <CartIcon style={{ fontSize: '16px', color: '#6b6b6c' }} />
                  </div>
                </div>

                <div style={{ height: '1px', background: '#e8e8e8', margin: '0 8px' }}></div>

                <Popconfirm
                  title="Are you sure would like to mark to Never sub?"
                  onConfirm={() => {
                    updateToNeverSub(record);
                    setExpandedRows(new Set());
                  }}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                  getPopupContainer={() => document.body}
                  overlayStyle={{ zIndex: 100000 }}
                  //COT-10411
                  onCancel={() => {
                    // Close the dropdown when user cancels the popconfirm
                    setExpandedRows(new Set());
                  }}
                >
                  <div
                  //COT-10411
                    onClick={(e) => {
                      // Stop propagation to prevent the click outside handler from triggering
                      e.stopPropagation();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    <span style={{
                      fontSize: '12px',
                      color: '#333',
                      fontWeight: '400',
                      width: '130px',
                      textAlign: 'left',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      Mark to Never Sub
                    </span>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <StopOutlined style={{ fontSize: '16px', color: '#6b6b6c' }} />
                    </div>
                  </div>
                </Popconfirm>
              </div>
            )}
          </div>
        );
      }
    };

    baseColumns.push(actionsColumn);

    return baseColumns;
  };

  const getFilteredColumns = () => {
    const allColumns = buildColumnsForTable();

    return allColumns.filter(column => {
      // Always show Actions column
      if (column.dataIndex === 'ruleType') return true;
      // Show other columns based on user selection
      return visibleColumns.includes(column.dataIndex);
    });
  };

  const getAllColumnsForModal = () => {
    // Base columns from CONST_OUTS_TABLE_COLUMNS
    const baseColumns = [...CONST_OUTS_TABLE_COLUMNS];

    // Add additional columns that might be conditionally shown
    const additionalColumns = [];

    // Add Total Outs column (from desktop version)
    // additionalColumns.push({
    //   title: 'Total Outs',
    //   dataIndex: 'totalOuts',
    //   width: 90,
    //   blankWidth: 90,
    // });

    // // Add Cutoff column (from desktop version)
    // additionalColumns.push({
    //   title: 'Cutoff',
    //   dataIndex: 'cutoff',
    //   width: 70,
    //   blankWidth: 70,
    // });

    // Always add Actions column for display in modal
    additionalColumns.push({
      title: 'Actions',
      dataIndex: 'ruleType'
    });

    return [...baseColumns, ...additionalColumns];
  };
  const handleTableChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };
  const resetSortedInfo = () => {
    setSortedInfo({
      sort: 'ascend',
      sortedBy: 'cutoff',
    });
  };
  const renderCellAsoh = (text, record) => {
    return (
      <div>
        <Button type="link" block onClick={() => handleViewInventoryDetail(record)}>
          {
            `${record.asoh}`
          }
        </Button>
      </div>
    )
  }
  const renderCellTotalOrders = (text, record) => {
    return (
      <Button type="link" block onClick={() => handleViewOrderDetail(record)}>
        {
          `${record.totalOrders}`
        }
      </Button>
    )
  }
  // const [pagination, setPagination] = useState(paginationSetting);
  const renderAllocateOriginaItemlWarningModal = (
    <ManageOutsWarningModal
      title=""
      isModalVisible={isAsohAvailableWarningVisible}
      footer={false}
      width={500}
      onToggleModal={() => { onToggleModal(setAsohAvailableWarningVisible); }}
      content="Available ASOH of the original item is not enough.Kindly add a subs item."
    />
  );
  const handleCancel = () => {
    onToggleModal(setReasonCodeHint);
  };
  const handleOk = () => {
    onToggleModal(setReasonCodeHint);
    const data = [];
    for (let order of allocatedRecord.orderDetailBeans) {
      const formData = {
        accountOwner: "",
        accountOwnerPhone: "",
        action: "A",
        approvalRequired: "",
        bosCutOff: 0,
        conceptId: allocatedRecord.nationalId ? allocatedRecord.nationalId : "",
        createdBy: auth.user.userId ? auth.user.userId : "",
        createdTimestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
        customerNumber: order.customerShipTo,
        dataType: "",
        dropFlag: "",
        effectiveEndDate: "",
        inclusionExclusion: "",
        localCentral: "",
        modifiedBy: "",
        modifiedTimestamp: "",
        orderDetailLineNumber: order.orderLine,
        orderNumber: order.orderNumber,
        originalBrand: allocatedRecord.originalItemBrand ? allocatedRecord.originalItemBrand : '',
        originalItem: allocatedRecord.originalItem,
        originalItemDescription: allocatedRecord.originalItemDescription,
        originalPack: allocatedRecord.originalItemPack ? allocatedRecord.originalItemPack : '',
        originalSize: allocatedRecord.originalItemSize ? allocatedRecord.originalItemSize : '',
        originalStorageCode: allocatedRecord.originalItemStorageCode ? allocatedRecord.originalItemStorageCode : '',
        originalSplitIndicator: allocatedRecord.originalItemUom === 'EA' ? 'Y' : 'N',
        reasonCode: "",
        reasonCodeDescription: "",
        ruleType: "AO",
        site: allocatedRecord.site,
        startOfDayEmail: "",
        subOutOfCatalog: "",
        subRatio: 0,
        subrulePriority: 0,
        substituteBrand: "",
        substituteItem: "",
        substituteItemDescription: "",
        substitutePack: "",
        substituteSize: "",
        substituteStorageCode: "",
        substitutelSplitIndicator: ""
      }
      data.push(formData);
    }
    const timing = Date.now();
    allocateOriginalItem(data).then((response) => {
      message.info('Allocate Original Item Successfully.');
    },
      (err) => {
        message.destroy();
        message.error(`Allocate Original Item Failed, please try again.`);
      });
    const removeData = {
      site: allocatedRecord.site,
      originalItem: allocatedRecord.originalItem,
      nationalId: allocatedRecord.nationalId ? allocatedRecord.nationalId : "",
      customerNumber: allocatedRecord.customerNumber ? allocatedRecord.customerNumber : "",
      orders: allocatedRecord.orderNumbers,
      createdById: auth.user.userId,
      originalItemDescription: allocatedRecord.originalItemDescription,
      callFrom: isViewDropOutVisible ? 'dropOuts' : 'outs',
    };
    removeAllocatedItem(removeData).finally(() => {
      const payload = { ...searchConditionData }
      if (searchText) {
        payload.originalItem = searchText
      }
      //COT-8309:Latency issue when user drop out or search for subs in manage outs
      // payload.optimizationEnable = optimizationEnable;  //COT-8330
      if (isViewDropOutVisible) {
        resetDropoutsData();
        fetchDropoutsData({ ...payload });
      } else {
        resetOutsData();
        fetchOutsData({ ...payload });
      }
    });
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Allocate Original Item`, timing);
    });
  };
  const renderDropOutResonModal = (
    <DropOutReasonModal
      // title=""
      isModalVisible={isDropOutResonVisible}
      footer={[
        <Button key="back" className="default-btn" onClick={() => cancelReasonModal()}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" className='primary-btn' style={{ marginLeft: "6px" }} onClick={() => handleRemoveDropOut(dropOutRecord)}>
          Proceed
        </Button>,
      ]}
      width={400}
      onToggleModal={() => cancelReasonModal()}
      content="Please select drop out reason"
      dropOutReason={dropOutReason}
      setDropOutReason={setDropOutReason}
    />
  )
  const renderReasonCodeHintModal = (
    <ManageOutsWarningModal
      title=""
      isModalVisible={isReasonCodeHint}
      footer={[
        <Button key="back" className="default-btn" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" className='primary-btn' style={{ marginLeft: "6px" }} onClick={handleOk}>
          Proceed
        </Button>,
      ]}
      width={500}
      onToggleModal={() => { onToggleModal(setReasonCodeHint); }}
      content="The original item was not allocated due to the below reason codes"
      record={allocatedRecord}
      isReasonCodeHint={true}
    />
  );
  const renderLockedWarningModal = (
    <ManageOutsWarningModal
      title=""
      isModalVisible={isLockedWarningModalVisible}
      footer={false}
      width={500}
      onToggleModal={() => { onToggleModal(setLockedWarningModalVisible); }}
      content="Maintenance is disabled for this record as this is being worked on by another user session."
    />
  );

  const renderOrderDetailModal = (
    <ManageOutsOperateModalMobile
      title="VIEW ORDER DETAILS"
      isModalVisible={isOrderDetailModalVisible}
      footer={false}
      width={1100}
      onToggleModal={() => { onToggleModal(setOrderDetailModalVisible); resetOrderDetail(); setSorting({ sort: 'descend', sortedBy: 'orderNumber' }) }}
      onTableChange={onTableChange}
      idle={() => { }}
    />
  );
  const renderInventoryDetailModal = (
    <ManageOutsOperateModalMobile
      title="VIEW INVENTORY DETAILS"
      isModalVisible={isInventoryDetailModalVisible}
      footer={false}
      width={650}
      onToggleModal={() => { onToggleModal(setInventoryDetailModalVisible); resetInventoryData(); }}
      idle={() => { }}

    />
  );
  const renderAddSubModal = (
    <ManageOutsOperateModalMobile
      title="ADDSUB"
      isModalVisible={isAddSubModalVisible}
      footer={false}
      width={1210}
      onToggleModal={() => { onToggleModal(setAddSubModalVisible); resetRecommendedProducts(); resetSubstituteProducts(); handleUpdateOutsRecordLock(selectedRecord) }}
      okText="Sub"
      baseData={baseData}
      idle={() => {
        notification.warning({
          message: `Idle Time Surpassed 5 minutes`,
          placement: 'top',
          duration: 0,
        })
      }}
    // optimizationEnable={optimizationEnable}
    />
  );
  const renderOutsParentElement = [
    { //render siteID
      extendRender: (value, label, record) => {
        return (
          <>
            <div className="col-title">{value}</div>
            <div className="col-desc">{record.siteDesc}</div>
          </>
        )
      }
    },
    { //render conceptID
      extendRender: (value, label, record) => {
        //defect:COT-5285, prioritize customer if customerNumber and national Id are not empty
        if (record.customerNumber && record.customerNumber.length > 0) {
          return (
            <>
              <div className="col-title">{record.customerNumber}</div>
              <div className="col-desc">{record.customerName}</div>
            </>
          )
        }
        return (
          <>
            <div className="col-title">{value}</div>
            <div className="col-desc">{record.nationalName}</div>
          </>
        )
        // if(value && value.length > 0) {
        //   return (
        //     <>
        //       <div className="col-title">{value}</div>
        //       <div className="col-desc">{record.nationalName}</div>
        //     </>
        //   )
        // }
        // return (
        //   <>
        //     <div className="col-title">{record.customerNumber}</div>
        //     <div className="col-desc">{record.customerName}</div>
        //   </>
        // )
      }
    },
    { //render originalItem
      extendRender: (value, label, record) => {
        let originalItemDetails = ``;
        if (value) {
          originalItemDetails = `${record.originalItemUom} | ${record.originalItemPack}/${record.originalItemSize} | ${record.originalItemBrand} | ${record.originalItemStorageCode}`;
        }
        let category = record.categorizationFlag;
        let categoryIcon = '';
        if (category) {
          category = category.trim();
          categoryIcon = category === 'C' ? <Badge className="sub-badge-item" color="#7AC943" />
            : category === 'D' ? <Badge className="sub-badge-item" color="#FF931E" />
              : category === 'B' ? <Badge className="sub-badge-item" color="#FFFF00" />
                : category === 'A' ? <Badge className="sub-badge-item" color="#FF1022" />
                  : <span className="blank-badge" />
        } else {
          categoryIcon = <span className="blank-badge" />
        }
        return (
          <>
            <div className="col-title">
              {categoryIcon}
              {value}
            </div>
            <div className="col-desc handle-overflow detail-info">{record.originalItemDescription}</div>
            <div className="col-desc handle-overflow detail-info">{originalItemDetails}</div>
          </>
        )
      }
    },
    //asoh placeholder
    {},
    //total orders placeholder
    {},
    //total outs placeholder
    {},
    // cut off placeholder
    {},
  ];
  const inputRef = useRef();
  let searchForm = null;
  let clearFiltersRef = null;
  let confirmRef = null;
  // const handleTerritoryParam = (values) => {
  //   let isCorpProfileUser = false
  //   if(originalList.length === 0) {
  //     const user = CORP_USER_LIST.filter(item => item.userId === userId);
  //     if (!_.isEmpty(user)) {
  //       isCorpProfileUser = true
  //     }
  //   }
  //   if((bosTerritoryData && ((bosTerritoryData.role && bosTerritoryData.role.toLowerCase() === 'corp') || _.isEmpty(bosTerritoryData.role))) || isCorpProfileUser) {
  //     let temp = values.territoryInfoList ? values.territoryInfoList.trim() : ''
  //     if(temp) {
  //       return [{"terrName": temp}]
  //     }else {
  //       return []
  //     }
  //   }else {
  //     return values.territoryInfoList !== undefined && values.territoryInfoList !== null ? uniqueTerritoryList(formatTerrirotyData(values, bosTerritoryData)) : null
  //   }
  // }
  const handleTerritoryParam = (values) => {
    let isCorpProfileUser = false
    if (originalList.length === 0) {
      const user = CORP_USER_LIST.filter(item => item.userId === userId);
      if (!_.isEmpty(user)) {
        isCorpProfileUser = true
      }
    }
    if ((bosTerritoryData && ((bosTerritoryData.role && bosTerritoryData.role.toLowerCase() === 'corp') || _.isEmpty(bosTerritoryData.role))) || isCorpProfileUser) {
      // Fix: Safely handle territoryInfoList regardless of type
      const territoryValue = values.territoryInfoList;
      let temp = '';

      if (territoryValue) {
        // Convert to string and trim, handling arrays by taking first element
        if (Array.isArray(territoryValue)) {
          temp = territoryValue.length > 0 ? String(territoryValue[0]).trim() : '';
        } else {
          temp = String(territoryValue).trim();
        }
      }

      if (temp) {
        return [{ "terrName": temp }]
      } else {
        return []
      }
    } else {
      return values.territoryInfoList !== undefined && values.territoryInfoList !== null ? uniqueTerritoryList(formatTerrirotyData(values, bosTerritoryData)) : null
    }
  }
  const handleOriginalItemSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0] ? selectedKeys[0] : storagedCondition?.originalItem);
    setSearchedColumn(dataIndex);
    const formVals = searchForm.getFieldsValue()
    if (formVals && formVals.sites && formVals.sites.length > 0) {
      saveSearchConditionData({
        ...formVals,
        deliveryDate: formVals.deliveryDate !== undefined && formVals.deliveryDate !== null ? parseInt(moment(formVals.deliveryDate).format(COMMON_DATE_FORMAT)) : null,
        customerNumber: formVals.customerNumber === '' ? null : formVals.customerNumber,
        territoryInfoList: handleTerritoryParam(formVals),
      });
      retainConditionData({ ...conditionData, ...formVals, originalItem: selectedKeys[0] ? selectedKeys[0] : storagedCondition?.originalItem });
    } else {
      message.error('Please select Site!')
    }
  };
  const handleOriginalItemReset = (clearFilters, confirm, dataIndex) => {
    setSearchText('');
    clearFilters();
    confirm({
      closeDropdown: true,
    });
    setSearchedColumn(dataIndex);
    const formVals = searchForm.getFieldsValue()
    if (formVals && formVals.sites && formVals.sites.length > 0) {
      saveSearchConditionData({
        ...formVals,
        deliveryDate: formVals.deliveryDate !== undefined && formVals.deliveryDate !== null ? parseInt(moment(formVals.deliveryDate).format(COMMON_DATE_FORMAT)) : null,
        customerNumber: formVals.customerNumber === '' ? null : formVals.customerNumber,
        territoryInfoList: handleTerritoryParam(formVals),
      });
      const condition = { ...conditionData };
      delete condition.originalItem;
      retainConditionData({ ...condition });
    } else {
      message.error('Please select Site!')
    }
  };
  const originalItemSearchReset = () => {
    setSearchText('');
    if (clearFiltersRef) {
      clearFiltersRef()
    }
    if (confirmRef) {
      confirmRef({
        closeDropdown: true,
      });
    }
  };
  const handleInputChg = (setSelectedKeys, e) => {
    setSelectedKeys(e.target.value ? [e.target.value] : []);
    retainConditionData({ ...conditionData, originalItem: e.target.value });
  }
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      clearFiltersRef = clearFilters;
      confirmRef = confirm;
      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={inputRef}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0] || storagedCondition?.originalItem}
            onChange={e => handleInputChg(setSelectedKeys, e)}
            onPressEnter={() => handleOriginalItemSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleOriginalItemSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleOriginalItemReset(clearFilters, confirm, dataIndex)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: filtered => <SearchOutlined style={{ fontSize: '16px', color: filtered || !_.isEmpty(storagedCondition?.originalItem) ? 'blue' : undefined }} />,
    // onFilter: (value, record) =>{
    //   return record[dataIndex]
    //     ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    //     : ''
    // },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => inputRef.current.select(), 100);
      }
    },
  });
  const searchFormCb = (form) => {
    searchForm = form;
  };
  const updateToNeverSub = (record) => {
    const args = {
      "site": record.site,
      "siteDesc": record.siteDesc,
      "nationalId": record.nationalId ? record.nationalId : "",
      "nationalName": record.nationalName ? record.nationalName : "",
      "originalItem": record.originalItem,
      "originalItemDescription": record.originalItemDescription,
      "originalUom": record.originalItemUom,
      "originalPack": record.originalItemPack,
      "originalSize": record.originalItemSize,
      "originalBrand": record.originalItemBrand,
      "originalStorageCode": record.originalItemStorageCode,
      "ruleType": "neversub",
      "createdByName": auth.user.userName,
      "createdById": userId,
      "createTimestamp": moment().format(DATE_TIME_TWO_FORMAT),
      "modifiedByName": auth.user.userName,
      "modifiedById": userId,
      "modifiedTimestamp": moment().format(DATE_TIME_TWO_FORMAT),
      "endDate": null,
      "customerNumber": record.customerNumber ? record.customerNumber : "",
      "customerName": record.customerName ? record.customerName : "",
      "expandedItems": null,
      "callFrom": isViewDropOutVisible ? 'dropOuts' : 'outs',
      "orders": record.orderDetailBeans.map(item => item.orderNumber) || [],
      "orderLines": record.orderDetailBeans.map(item => item.orderLine) || [],
      "customerNumbers": record.orderDetailBeans.map(item => item.customerShipTo) || [],
    }
    onUpdateSubs(args, null, false, null);
  }
  const onUpdateSubs = (formaData, onCloseModal, wasDropout, expandedLength) => {
    const timing = Date.now();
    const args = {
      ...formaData, "customerNumber": formaData.customerNumber ? formaData.customerNumber : "",
      "customerName": formaData.customerName ? formaData.customerName : "",
      "nationalId": formaData.nationalId ? formaData.nationalId : "",
      "nationalName": formaData.nationalName ? formaData.nationalName : "",
    }
    updateSubstitutionsData(args).then(data => {
      if (wasDropout && args.expandedItems != null) {
        if (expandedLength === null && args.expandedItems.length === 0) {
          message.success(`Deleted Drop out rule Successfully.`);
        } else if (expandedLength === null && args.expandedItems.length > 0 && args.dropOutRuleEndDate === undefined) {
          message.success(`Deleted Drop out rule Successfully.`);
          message.success(`Updated Substitutions Successfully.`);
        } else if (expandedLength !== null && args.expandedItems.length >= 0 && args.dropOutRuleEndDate === undefined) {
          message.success(`Deleted Drop out rule Successfully.`);
          message.success(`Updated Substitutions Successfully.`);
        } else {
          message.success(`Updated Substitutions Successfully.`);
        }
      } else {
        message.success(`Updated Substitutions Successfully.`);
      }
      // onCloseModal && onCloseModal();
      if (searchConditionData) {
        const formData = {
          ...searchConditionData,
          //pageIndex: CONST_PAGINATION_TEN.pageIndex,
          //pageSize: CONST_PAGINATION_TEN.pageSize,
          pageIndex: sessionStorage.getItem('pageIndex'),
          pageSize: sessionStorage.getItem('pageSize'),

        };
        if (searchText) {
          formData.originalItem = searchText
        }
        if (isViewDropOutVisible) {
          resetDropoutsData()
          fetchDropoutsData(formData)
        } else {
          resetOutsData();
          fetchOutsData(formData);
        }
      }
    }).catch(err => {
      if (wasDropout && args.expandedItems != null) {
        if (expandedLength === null && args.expandedItems.length === 0) {
          message.error(`Delete Drop out Sub rule Failed, please try again.`);
        } else {
          if (err.isInvalidShipTo) {
            message.error(err.message)
          } else {
            message.error(`Update Substitutions Failed, please try again.`);
          }
        }
      } else {
        if (err.isInvalidShipTo) {
          message.error(err.message)
        } else if (err?.response?.status === 400) {
          message.error(err?.response?.data?.description);
        } else {
          message.error(`Update Substitutions Failed, please try again.`);
        }
      }
    });
    datadogRum.onReady(function () {
      datadogRum.addTiming(`Update Subs`, timing);
    });
  }

  const toggleActionsDropdown = (recordKey) => {
    setExpandedRows(prevExpandedRows => {
      const newExpandedRows = new Set();

      // If the clicked row is not currently expanded, open it (and close all others)
      if (!prevExpandedRows.has(recordKey)) {
        newExpandedRows.add(recordKey);
      }
      // If the clicked row is already expanded, close it (newExpandedRows remains empty)

      return newExpandedRows;
    });
  };


  useEffect(() => {
    if (storagedCondition && storagedCondition?.isViewDropOutVisible) {
      setViewDropOutModalVisible(storagedCondition?.isViewDropOutVisible);
    }
    if (storagedCondition && storagedCondition?.selectedKeys) {
      setSearchText(storagedCondition?.selectedKeys);
    }
  }, [storagedCondition]);

  //COT-10381: Close Actions dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Don't close if clicking on a popconfirm element
      //COT-10411
      if (event.target.closest('.ant-popover') ||
        event.target.closest('.ant-popconfirm')) {
        return;
      }

      // Don't close if clicking inside any dropdown
      if (event.target.closest('[style*="position: absolute"]')) {
        return;
      }//COT-10411
    
      // Close dropdown when clicking outside
      if (expandedRows.size > 0) {
        setExpandedRows(new Set());
      }
    };

    // Add event listener when any dropdown is open
    if (expandedRows.size > 0) {
      document.addEventListener('click', handleClickOutside);
    }

    // Cleanup event listener
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [expandedRows]);
  //COT-10381
  return (
    <div className="manage-subs-manage-outs">
      <Spin spinning={exportOutsDataPending}>
        <div className="chart-title font-size-16-bold" style={{ font: "Myriad Bold" }}>Search Outs</div>
        {/* defect:cot-5316,when click reload will reset ccc/cst local option as same as search condition */}
        <SearchFiltersPanel isOnClickRefresh={isOnClickRefresh} searchForm={searchFormCb} originalItemSearchReset={originalItemSearchReset} resetSortedInfo={resetSortedInfo} searchText={searchText} />
        <div className="flex align-item-center justify-end" style={{ marginBottom: "20px", marginTop: "-45px" }}>


          {/* COT-10377*/}
          <div className="action-buttons-container" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {/* Reload Button */}
            <Button
              type="link"
              title="Reload"
              disabled={_.isEmpty(searchConditionData)}
              onClick={onRefreshOuts}
              className="action-button reload-button"
            >
              <div className="button-content">
                <FontAwesomeIcon
                  icon={faArrowsRotate}
                  color={_.isEmpty(searchConditionData) ? "#a1a1a2" : "#6b6b6c"}
                  style={{ height: "15px", width: "15px" }}
                />
                <span className="button-label">Reload</span>
              </div>
            </Button>

            {/* View Drop Outs Button */}
            <Button
              type="link"
              title="View Drop Outs"
              disabled={_.isEmpty(searchConditionData)}
              onClick={handleViewDropouts}
              className="action-button view-dropouts-button"
            >
              <div className="button-content">
                <FontAwesomeIcon
                  icon={faEye}
                  color={_.isEmpty(searchConditionData) && !storagedCondition?.isViewDropOutVisible ? "#a1a1a2" : (isViewDropOutVisible ? "#40a9ff" : "#6b6b6c")}
                  style={{ height: "15px", width: "15px" }}
                />
                <span className="button-label">View Drop Outs</span>
              </div>
            </Button>

            {/* Settings Button - Only for mobile phones, not tablets */}
            {!isTablet && (
              <Button
                ref={settingsButtonRef}
                type="link"
                title="Settings"
                onClick={handleSettingsClick}
                className="action-button settings-button"
              >
                <span className="settings-icon">
                  <FontAwesomeIcon
                    icon={faGears}
                    style={{ color: '#ffffff', fontSize: '17px', transform: 'rotate(95deg)' }}
                  />
                </span>
              </Button>
            )}

            {/* Export Button - Only for tablets */}
            {isTablet && (
              <Button
                type="link"
                title={exportOutsDataPending ? 'Exporting...' : "Export"}
                disabled={_.isEmpty(searchConditionData) || exportOutsDataPending}
                onClick={onExportOuts}
                className="action-button export-button"
              >
                <div className="button-content">
                  <FontAwesomeIcon
                    icon={faFileExport}
                    color={_.isEmpty(searchConditionData) ? "#a1a1a2" : "#6b6b6c"}
                    style={{ height: "15px", width: "15px" }}
                  />
                  <span className="button-label">Export</span>
                </div>
              </Button>
            )}
          </div>
        </div>
        <CommonTable
          //defect:COT-5293、5294、5295, help Melody to commit
          rowKey={record => `${record.uid}-${record.site}-${record.nationalId}-${record.customerNumber}-${record.originalItem}-${record.originalItemUom}`}
          //columns={outsParentColumns}
          columns={getFilteredColumns()}
          tableClassName={outsData || dropoutsData ? "outs-report-table" : ""}
          datasource={isViewDropOutVisible ? dropoutsData : outsData}
          loadingData={fetchOutsDataPending || checkOutsLockPending || updateOutsRecordLockPending || removeDropOutsPending ||
            fetchDropoutsDataPending || removeAllocatedItemPending || allocateOriginalItemPending}
          paginationStyle={{ textAlign: "right", margin: '16px 0px' }}
          triggerConditions={searchConditionData}
          searchText={searchText}
          onFecthData={isViewDropOutVisible ? fetchDropoutsData : fetchOutsData}
          onResetStore={isViewDropOutVisible ? resetDropoutsData : resetOutsData}
          //scrollStyle={{ x: 'max-content', y: 300 }}
          scrollStyle={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
          paginationSetting={CONST_PAGINATION_TEN}
          //paginationSetting={pagination}
          key={location.pathname}
          isManageOuts={true}
          isdropout={isViewDropOutVisible ? "yes" : null}
          isRefreshed={isOnClickRefresh}
          onOutsTableChange={handleTableChange}
          // optimizationEnable={optimizationEnable}
          sorting={sortedInfo}
        />
        {isOrderDetailModalVisible && renderOrderDetailModal}
        {isInventoryDetailModalVisible && renderInventoryDetailModal}
        {isAddSubModalVisible && renderAddSubModal}
        {isLockedWarningModalVisible && renderLockedWarningModal}
        {isAsohAvailableWarningVisible && renderAllocateOriginaItemlWarningModal}
        {isReasonCodeHint && renderReasonCodeHintModal}
        {isDropOutResonVisible && renderDropOutResonModal}
      </Spin>

      {isColumnSelectionVisible && (
        <ColumnSelectionModal
          isVisible={isColumnSelectionVisible}
          onClose={() => setColumnSelectionVisible(false)}
          isViewDropOutVisible={isViewDropOutVisible}
          isManageOutsScreen={true}
          baseColumns={getAllColumnsForModal()}
          visibleColumns={visibleColumns}
          onColumnChange={handleColumnChange}
          triggerElement={settingsButtonRef.current} // Pass the button element
        />
      )}
    </div>
  );
};
